import { NetworkStatus } from "@apollo/client";
import { Backdrop, Box, Grid } from "@material-ui/core";
import OrderProcessingView, {
  OrderProcessStatus
} from "@saleor/apps/components/OrderProcessing";
import ModalProcessing from "@saleor/apps/components/OrderProcessing/ModalProcessing";
import { isStaffRole } from "@saleor/auth/hooks/useUserRole";
import AtpCtpDialog from "@saleor/changeOrder/components/AtpCtpDialog";
import OrderBeingProcessError from "@saleor/changeOrder/components/OrderBeingProcessError";
import AddNewItem from "@saleor/changeOrderDomestic/components/AddNewItem";
import ChangeOrderFooter from "@saleor/changeOrderDomestic/components/ChangeOrderFooter";
import DialogConfirmCancelItem from "@saleor/changeOrderDomestic/components/DialogConfirmCancelItem";
import HeaderTabView from "@saleor/changeOrderDomestic/components/HeaderTab";
import ItemDetailsTab from "@saleor/changeOrderDomestic/components/ItemDetailsTab";
import ItemDetailsTabEdit from "@saleor/changeOrderDomestic/components/ItemDetailsTabEdit";
import ModalSendMail from "@saleor/changeOrderDomestic/components/ModalSendMail";
import { CONDITION_TYPE } from "@saleor/changeOrderDomestic/const";
import { changeOrderPathUrl } from "@saleor/changeOrderDomestic/urls";
import {
  checkHasPriceAffectingChanges,
  getTotalNetPriceByLine
} from "@saleor/changeOrderDomestic/utils";
import {
  ChangeOrderCSTab,
  ContentHeaderTab,
  ErrorFields,
  ItemTab,
  ModalConfirmDeleteProps,
  TypeConfirm,
  typeConfirmDelete,
  ViewEditMode
} from "@saleor/changeOrderDomestic/views/ViewEditOrder/types";
import DialogConfirmChangeOrder from "@saleor/changeOrderExport/components/DialogConfirmChangeOrder/DialogConfirmChangeOrder";
import AppHeader from "@saleor/components/AppHeader";
import Container from "@saleor/components/Container";
import CreditBlockDialog from "@saleor/components/CreditBlockDialog";
import CustomerBlockDialog from "@saleor/components/CustomerBlockDialog";
import DialogConfirm from "@saleor/components/DialogConfirm";
import DialogConfirmError from "@saleor/components/DialogConfirmError";
import DialogConfirmWarning from "@saleor/components/DialogConfirmWarning";
import DialogProcessing from "@saleor/components/DialogProcessing/DialogProcessing";
import MyTypography from "@saleor/components/MyTypography";
import PageHeader from "@saleor/components/PageHeader";
import SnackbarAlert from "@saleor/components/SnackbarAlert";
import { Tab, TabContainer } from "@saleor/components/Tab";
import TimeOutPage from "@saleor/components/TimeOutPage";
import { defaultListSettings, STAFF_UPDATE } from "@saleor/config";
import {
  checkIsCashSaleOrder,
  findChangeOrderCashSaleEditedField,
  getCashSaleState,
  getCashSaleStatusText,
  prepareCashSalePayload
} from "@saleor/createOrChangeNotRefContract/utils";
import useCashSaleForm from "@saleor/createOrder/components/CashSaleForm/useCashSaleForm";
import DialogCreateOrderError from "@saleor/createOrder/components/DialogCreateOrderError";
import InvalidModal from "@saleor/createOrder/components/InvalidModal";
import { orderCartPath, previewOrderPath } from "@saleor/createOrder/urls";
import DrawAddProductDomestic from "@saleor/createOrderDomestic/components/DrawAddProductDomestic";
import {
  contractDetaiUrlParamTab,
  DomesticOrderQueryParams,
  DomesticOrderSortField
} from "@saleor/createOrderDomestic/urls";
import {
  ModeUpdate,
  TypeOfApplyAll
} from "@saleor/createOrderDomestic/views/CreateOrderView";
import DialogError from "@saleor/createOrderExport/components/DialogError";
import {
  ChangeOrderItemDetailsInput,
  DeliveryUnlimited,
  InquiryMethodType,
  ReasonForChangeRequestDateEnum,
  useCancelDeleteOrderLinesMutation,
  useChangeOrderAddNewOrderLineMutation,
  useChangeOrderUpdateMutation,
  useCheckContractExpiredCompleteInvalidMutation,
  useCheckoutAtpctpConfirmMutationMutation,
  useContractChangeOrderDomesticQuery,
  useContractLazyQuery,
  useDeleteAndSyncOrderLineMutation,
  useDownloadPdfOrderMutation,
  useDuplicateOrderMutation,
  useGetArOutstandingQuery,
  useGetCashSaleStatusLazyQuery,
  useGetCreditLimitQuery,
  useGetCustomerBlockQuery,
  useGetCustomerGroupMasterQuery,
  useGetIncotermQuery,
  useShowAtpCtpPopupLazyQuery,
  useSubmitCashSaleUpdateMutation,
  useUndoOrderLinesMutation,
  WeightUnitEnum
} from "@saleor/graphql";
import useAppState from "@saleor/hooks/useAppState";
import useBulkActions from "@saleor/hooks/useBulkActions";
import useListSettings from "@saleor/hooks/useListSettings";
import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import usePaginationLocal from "@saleor/hooks/usePaginationLocal";
import { makeStyles } from "@saleor/macaw-ui";
import { ListViews } from "@saleor/types";
import { PROD_CATEG_1 } from "@saleor/utils/constants";
import createSortHandler from "@saleor/utils/handlers/sortHandler";
import {
  getIPlanMessages,
  getIPlanMessagesCancelItem
} from "@saleor/utils/message";
import { roundDecimal } from "@saleor/utils/number";
import { getSortParams, getSortUrlVariables } from "@saleor/utils/sort";
import { buildUrl } from "@saleor/utils/urls";
import cls from "classnames";
import cloneDeep from "lodash/cloneDeep";
import _max from "lodash/max";
import _maxBy from "lodash/maxBy";
import moment from "moment/moment";
import React, { ReactNode, useEffect, useMemo, useState } from "react";
import { useIntl } from "react-intl";
import { useHistory } from "react-router";

export interface ViewEditProps {
  id: string;
  params: DomesticOrderQueryParams;
}

interface StyleProps {
  fullScreen?: boolean;
}

interface ModalConfirm {
  title: ReactNode | string;
  content: ReactNode | string;
  type: TypeConfirm;
  lineId?: string;
  dataHeader?: any;
  okText?: string;
  cancelText?: string;
  item?: any;
}

enum StatusCancel {
  "CANCEL" = "Cancel",
  "DELETE" = "Delete"
}

export interface IListLine {
  refDocIt?: string;
  weightPerUnit: string;
  weightBase: number;
  id: string;
  comfirmQty: string;
  contractItemNo: string;
  contractNo: string;
  deliveryQty: string;
  deliveryStatus: string;
  itemCategory: string;
  itemNo: string;
  itemQty: string;
  quantity: string;
  pricePerUnit: string;
  material: string;
  materialDesc: string;
  materialGroup1: string;
  orderQty: string;
  paymentTerm: string;
  plant: string;
  poNumber: string;
  prdHierachy: string;
  requestedDate: string;
  routeId: string;
  routeName: string;
  saleQtyDivision: string;
  saleQtyFactor: string;
  saleText1Th: string;
  salesUnit: string;
  shippingPoint: string;
  deliveryTolUnlimited: boolean;
  overDeliveryTol: string;
  underDeliveryTol: string;
  rootUnit: string;
  errorQuantity: boolean;
  errorDate: string | boolean;
  externalCommentsToCustomer: string;
  shippingMark: string;
  internalCommentsToLogistic: string;
  internalCommentsToWarehouse: string;
  productInformation: string;
  product_Information: string;
  billTo: string;
  requestDate: string;
  route: string;
  shipTo: string;
  status: string;
  itemRemain: string;
  orderNo: string;
  requestDateChangeReason: ReasonForChangeRequestDateEnum;
  statusCancel: string;
  isNewAddItem: boolean;
  weightUnit: WeightUnitEnum;
  weightUnitTon: WeightUnitEnum;
  weightDisplay: WeightUnitEnum;
  contractProductId: string;
  remainWeight: number;
  isSplit: boolean;
  hasSplit: boolean;
  originalId: string;
  originQuantity: number;
  poNo: string;
  confirmedDate: Date;
  isEditRequestDate: boolean;
  flagR5: boolean;
  inquiryMethod: InquiryMethodType;
  consignmentLocation?: string;
  sapConfirmStatus?: string;
  originalRequestDate?: string;
  assignQuantity: number;
}

const HeaderTab = Tab(ChangeOrderCSTab.header);
const ItemDetailTab = Tab(ChangeOrderCSTab.itemDetails);
const AddNewItemTab = Tab(ChangeOrderCSTab.addNewItem);

const useStyles = makeStyles<StyleProps>(
  theme => ({
    pageHeader: {
      marginBottom: "1.2rem",
      "& > :first-child": {
        visibility: props => (props.fullScreen ? "hidden" : "visible"),
        margin: 0,
        marginBottom: props => (props.fullScreen ? "0.4rem" : "1.2rem")
      },
      "& > :nth-child(2)": {
        alignSelf: "flex-end"
      }
    },
    boxContainer: {
      paddingBottom: "20rem"
    },
    tab: {
      padding: "10px 0",
      textAlign: "center"
    },
    tabBox: {
      "&>span:first-child": {
        borderRadius: "12px 0 0 0"
      },
      "&>span:last-child": {
        borderRadius: "0 12px 0 0"
      }
    },
    snackHeadTitle: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      columnGap: "1.2rem"
    },
    backDrop: {
      zIndex: 1399
    },
    boxInfo: {
      marginTop: "3rem"
    },
    SoNo: {
      color: theme.palette.info.main
    },
    alignRight: {
      textAlign: "right"
    },
    textRed: {
      color: theme.palette.error.light
    },
    displayNone: {
      display: "none"
    },
    titleGradient: {
      background:
        "linear-gradient(90deg, #601863 0%, #681661 12%, #81125C 32%, #A90C55 57%, #DF044A 86%, #FD0045 100%)",
      WebkitTextFillColor: "transparent",
      WebkitBackgroundClip: "text"
    },
    inlineBlock: {
      display: "inline-block",
      color: theme.palette.grey[900]
    },
    warpModalProcessing: {
      position: "fixed",
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      background: "rgba(0,0,0,0.2)",
      zIndex: 99999
    },
    modalProcessing: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%,-50%)",
      zIndex: 99999
    },
    titleMain: {
      color: theme.palette.info.main
    }
  }),
  { name: "OrdersViewDomestic" }
);

const ViewEditOrdersView: React.FC<ViewEditProps> = ({ id, params }) => {
  const intl = useIntl();
  const navigate = useNavigator();
  const history = useHistory();

  const TAX_PERCENT = 0.07;

  const [{ fullScreen, viewEditMode }, dispatchAppState] = useAppState();
  const classes = useStyles({ fullScreen });
  const [orderProcessStatus, setOrderProcessStatus] = useState<
    OrderProcessStatus
  >(OrderProcessStatus.inconclusive);

  const [openConfirmOrder, setOpenConfirmOrder] = useState<boolean>(false);
  const [beingProcessMsg, setBeingProcessMsg] = useState<string>("");
  const [openSendMail, setOpenSendMail] = useState<boolean>(false);
  const [openConfirmAddNewItem, setOpenConfirmAddNewItem] = useState<boolean>(
    false
  );
  const [openCancelAddNewItem, setOpenCancelAddNewItem] = useState<boolean>(
    false
  );
  const [openCancelEdit, setOpenCancelEdit] = useState<boolean>(false);
  const [dataModalConfirm, setDataModalConfirm] = useState<ModalConfirm>({
    type: undefined,
    content: undefined,
    title: undefined
  });
  const [activeTab, setActiveTab] = useState<ChangeOrderCSTab>(
    ChangeOrderCSTab.header
  );
  const [componentKey, setComponentKey] = useState<number>(0);
  const [applyAllKey, setApplyAllKey] = useState<number>(0);
  const [submitKey, setSubmitKey] = useState<number>(0);
  const [listLineOrderInitial, setListLineOrderInitial] = useState<IListLine[]>(
    []
  );
  const [listLineOrder, setListLineOrder] = useState<IListLine[]>([]);
  const [listLineOrderNotCallAtpCTP, setListLineOrderNotCallAtpCTP] = useState<
    IListLine[]
  >([]);
  const [openModalConfirmDelete, setOpenModalConfirmDelete] = useState<boolean>(
    false
  );
  const [dataModalConfirmDelete, setDataModalConfirmDelete] = useState<
    ModalConfirmDeleteProps
  >({});
  const [openModalConfirmCancel, setOpenModalConfirmCancel] = useState<boolean>(
    false
  );
  const [openDrawATP, setOpenDrawATP] = useState<boolean>(false);
  const [dataDrawATP, setDataOpenATP] = useState<IListLine[]>([]);

  const [isSuccessfully, setSuccessfully] = useState<TypeOfApplyAll | null>(
    null
  );
  const [mode, setMode] = useState<ModeUpdate | null>(null);
  const [
    modeCustomerBlock,
    setModeCustomerBlock
  ] = useState<ViewEditMode | null>(null);
  const [openDrawAddProduct, setOpenDrawAddProduct] = useState<boolean>(false);
  const [activeHeaderTab, setActiveHeaderTab] = useState<ContentHeaderTab>(
    ContentHeaderTab.partner
  );

  const [openGLDateErrorPopup, setOpenGLDateErrorPopup] = useState<boolean>(
    false
  );
  const [openDialogAtpCtpError, setOpenDialogAtpCtpError] = useState<boolean>(
    false
  );
  const [openR5ErrorPopup, setOpenR5ErrorPopup] = useState<boolean>(false);
  const [activeItemTab, setActiveItemTab] = useState<ItemTab>(ItemTab.tabA);
  const [openError, setOpenError] = useState<boolean>(false);
  const [itemErrors, setItemErrors] = useState<string[]>([]);
  const [itemErrorsR5, setItemErrorsR5] = useState<string[]>([]);

  const [billToInsteaded, setBillToInsteaded] = useState<string>("");
  const [shipToInsteaded, setShipToInsteaded] = useState<string>("");
  const [openCustomerBlock, setOpenCustomerBlock] = useState<boolean>(false);
  const [openCreditBlock, setOpenCreditBlock] = useState<boolean>(false);

  const { updateListSettings, settings } = useListSettings(
    ListViews.EDIT_ORDER_DOMESTIC
  );

  const [isDisapearItem, setIsDisapearItem] = useState<boolean>(false);
  const [openCreateOrderError, setOpenCreateOrderError] = useState<boolean>(
    false
  );
  const [isOpenInvalidOrderError, setIsOpenInvalidOrderError] = useState<
    boolean
  >(false);
  const [isOpenProcessingAtpCtp, setIsOpenProcessingAtpCtp] = useState<boolean>(
    false
  );
  const [orderProcessError, setOrderProcessError] = useState("");
  const [itemNoLatest, setItemNoLatest] = useState<number>();
  const [splitLineId, setSplitLineId] = useState<string>("");
  const [cancelEditCall, setCancelEditCall] = useState<boolean>(false);

  const [dialogError, setDialogError] = useState(false);
  const [errorSource, setErrorSource] = useState("");
  const [errorOrders, setErrorOrders] = useState([]);
  const [errorItems, setErrorItems] = useState([]);

  const [popUpContent, setPopUpContent] = useState(null);
  const [openConfirmReload, setOpenConfirmReload] = useState<boolean>(false);

  const isStaff = isStaffRole();

  const toggleCloseCreateOrderError = () => {
    setOpenCreateOrderError(val => !val);
  };
  const clearErrorOrders = () => {
    setErrorOrders([]); // Set errorOrders to an empty array
  };
  const notify = useNotifier();

  const showErrorNotification = (sapErrorOrders, sapErrorItems) => {
    notify({
      status: "error",
      title: "Something went wrong",
      text: (
        <>
          <Box>
            <b>Error SAP</b>
          </Box>
          <Box>{`${sapErrorOrders}  ${sapErrorItems}`}</Box>
        </>
      )
    });
  };

  const {
    data: dataChangeOrder,
    loading: loadingChangeOrder,
    networkStatus: networkStatusChangeOrder,
    refetch: refetchChangeOrder
  } = useContractChangeOrderDomesticQuery({
    variables: {
      soNo: id
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "no-cache",
    onCompleted: data => {
      const { changeOrder } = data ?? {};

      fetchCashSaleStatus(changeOrder?.soNo, changeOrder?.orderType);
    }
  });

  async function refetchChangeOrderData() {
    return refetchChangeOrder().then(result => {
      const { changeOrder } = result?.data ?? {};

      fetchCashSaleStatus(changeOrder?.soNo, changeOrder?.orderType);

      return result;
    });
  }

  const [deleteAndSyncOrderLine] = useDeleteAndSyncOrderLineMutation({
    fetchPolicy: "no-cache"
  });

  const [
    checkContractExpiredCompleteInvalid,
    { data: dataCheckContractExpiredCompleteInvalid }
  ] = useCheckContractExpiredCompleteInvalidMutation({
    variables: {
      contractNo: dataChangeOrder?.changeOrder?.contractNo
    }
  });

  const [
    acceptAtpItem,
    { loading: loadingAtpCtp }
  ] = useCheckoutAtpctpConfirmMutationMutation({
    onCompleted(data) {
      if (
        data?.checkoutAtpCtpConfirm?.iPlanMessages?.length === 0 &&
        data?.checkoutAtpCtpConfirm?.sapItemMessages?.length === 0 &&
        data?.checkoutAtpCtpConfirm?.sapOrderMessages?.length === 0 &&
        data?.checkoutAtpCtpConfirm?.errors?.length === 0
      ) {
        refetchChangeOrderData();
        setDataOpenATP(oldDataAtp =>
          oldDataAtp.filter(dataAtp =>
            data?.checkoutAtpCtpConfirm?.items.every(
              item => item.originalItemNo !== dataAtp.itemNo
            )
          )
        );
        setIsOpenProcessingAtpCtp(false);
        return;
      }

      if (data?.checkoutAtpCtpConfirm?.errors?.length > 0) {
        notify({
          status: "error",
          sourceSystem: "Eordering",
          apiMessage: data?.checkoutAtpCtpConfirm?.errors
            ?.map(item => `${item.code} - ${item.message}`)
            .join("\n")
        });

        setIsOpenProcessingAtpCtp(false);
        return;
      }

      if (data?.checkoutAtpCtpConfirm?.iPlanMessages?.length > 0) {
        notify({
          status: "error",
          sourceSystem: "Iplan",
          apiMessage: data?.checkoutAtpCtpConfirm?.iPlanMessages
            ?.map(
              item => `${item.firstCode}${item.secondCode} - ${item.message}`
            )
            .join("\n")
        });

        setIsOpenProcessingAtpCtp(false);
        return;
      }

      if (data?.checkoutAtpCtpConfirm?.sapOrderMessages?.length > 0) {
        notify({
          status: "error",
          sourceSystem: "SAP",
          apiMessage: data?.checkoutAtpCtpConfirm?.sapOrderMessages
            ?.map(item => `${item.errorCode} - ${item.errorMessage}`)
            .join("\n")
        });

        setIsOpenProcessingAtpCtp(false);
        return;
      }

      if (data?.checkoutAtpCtpConfirm?.sapItemMessages?.length > 0) {
        notify({
          status: "error",
          sourceSystem: "SAP",
          apiMessage: data?.checkoutAtpCtpConfirm?.sapItemMessages
            ?.map(
              item =>
                `${item.itemNo || ""} ${item.errorCode || ""} - ${
                  item.errorMessage
                }`
            )
            .join("\n")
        });

        setIsOpenProcessingAtpCtp(false);
        return;
      }

      const newListLineOrderNotCallAtpCTP = [];
      listLineOrder.forEach(item => {
        dataDrawATP.forEach(element => {
          if (item.itemNo !== element.itemNo) {
            newListLineOrderNotCallAtpCTP.push(item);
          }
        });
      });

      setListLineOrderNotCallAtpCTP(newListLineOrderNotCallAtpCTP);
      refetchChangeOrderData().then(() => {
        setCancelEditCall(true);
        setIsOpenProcessingAtpCtp(false);
      });
      setIsDisapearItem(true);
      setTimeout(() => {
        setCancelEditCall(false);
        setIsDisapearItem(false);
      }, 1000);
    },
    onError(err) {
      setIsOpenProcessingAtpCtp(false);
      notify({
        status: "error",
        apiMessage: err.message
      });
    }
  });

  const [
    cancelDeleteItem,
    { loading: loadingCancelDeleteItem }
  ] = useCancelDeleteOrderLinesMutation();

  useEffect(() => {
    dispatchAppState({
      type: "setFullScreen",
      payload: {
        value: false
      }
    });
    updateListSettings(
      "rowNumber",
      defaultListSettings.EDIT_ORDER_DOMESTIC.rowNumber
    );
    if (params.editMode) {
      setViewEditMode(params.editMode);
    } else {
      setViewEditMode(ViewEditMode.VIEW);
    }
    setActiveTab(ChangeOrderCSTab.header);
    return () => {
      setCountChange(0);
      setViewEditMode(ViewEditMode.VIEW);
    };
  }, []);

  const {
    data: dataIncoterm,
    loading: loadingInCoTerm
  } = useGetIncotermQuery();
  const { data: dataCustomerGroup } = useGetCustomerGroupMasterQuery();

  const getId = (arr: Array<{ id: string; code: string }>, code: string) => {
    if (!Array.isArray(arr)) {
      return undefined;
    }
    return arr.find(item => item?.code === code)?.id;
  };

  const soldToCode = useMemo(() => {
    let _soldToCode = "";
    // eslint-disable-next-line chai-friendly/no-unused-expressions
    dataChangeOrder?.changeOrder?.orderPartners?.forEach(orderPartner => {
      if (orderPartner?.partnerRole === "AG") {
        _soldToCode = orderPartner?.partnerNo;
      }
    });
    return _soldToCode;
  }, [dataChangeOrder?.changeOrder?.orderPartners]);

  const getSoldToName = () => {
    let _soldToName = "";
    // eslint-disable-next-line chai-friendly/no-unused-expressions
    dataChangeOrder?.changeOrder?.orderPartners?.forEach(orderPartner => {
      if (orderPartner?.partnerRole === "AG") {
        _soldToName = orderPartner?.address[0].name;
      }
    });
    return _soldToName;
  };

  const getSoldToText = () => {
    let _soldToText = "";
    // eslint-disable-next-line chai-friendly/no-unused-expressions
    dataChangeOrder?.changeOrder?.orderPartners?.forEach(orderPartner => {
      if (orderPartner?.partnerRole === "AG") {
        _soldToText = `${orderPartner?.partnerNo} - ${orderPartner?.address[0].name}`;
      }
    });
    return _soldToText;
  };

  /*   const taxPercent = useMemo(() => dataChangeOrder?.changeOrder?.taxPercent || 0, [
    dataChangeOrder
  ]); */

  const [
    getCashSaleStatus,
    {
      data: cashSaleStatusData,
      loading: loadingGetCashSaleStatus,
      error: cashSaleStatusError
    }
  ] = useGetCashSaleStatusLazyQuery({
    fetchPolicy: "no-cache"
  });

  const fetchCashSaleStatus = (soNo: string, orderType: string) => {
    const isCashSaleOrder = checkIsCashSaleOrder(orderType);
    if (!isCashSaleOrder || !soNo) {
      return;
    }
    getCashSaleStatus({
      variables: {
        soNo
      }
    });
  };

  const {
    isCashSaleOrder,
    isCashSaleAvailableForStatus,
    isEditableCashSale,
    disabledActionForCashSale
  } = getCashSaleState({
    isChangeFlow: true,
    orderType: dataChangeOrder?.changeOrder?.orderType,
    orderStatus: dataChangeOrder?.changeOrder?.status,
    cashSaleStatusData
  });

  const arOutstandingResult = useGetArOutstandingQuery({
    fetchPolicy: "no-cache",
    variables: {
      input: {
        saleOrgCode: dataChangeOrder?.changeOrder?.salesOrg,
        soldToCode
      }
    },
    skip:
      !isCashSaleOrder ||
      !isCashSaleAvailableForStatus ||
      !dataChangeOrder?.changeOrder?.salesOrg ||
      !soldToCode
  });

  const prodErrorContent = (
    <>
      {" "}
      <MyTypography variant="body2" className={classes.inlineBlock}>
        กรุณาเลือก{" "}
        <MyTypography variant="subtitle2" className={classes.inlineBlock}>
          สินค้ากลุ่มเดียวกัน
        </MyTypography>{" "}
        ในการสร้างคำสั่งซื้อ
      </MyTypography>
    </>
  );

  const [
    duplicateOrder,
    { loading: loadingDuplicate }
  ] = useDuplicateOrderMutation({
    variables: {
      id
    },
    onCompleted: data => {
      if (data?.duplicateOrder?.order?.id) {
        navigate(orderCartPath(data?.duplicateOrder?.order?.id));
      } else if (
        data?.duplicateOrder?.errors[0]?.code === "PRODUCT_GROUP_ERROR"
      ) {
        setOpenError(true);
        setPopUpContent(prodErrorContent);
      }
    }
  });

  const [
    downloadPdfOrder,
    { loading: loadingDownloadPdf }
  ] = useDownloadPdfOrderMutation({
    variables: {
      orderId: id,
      sortType: getSortParams(params).asc ? "ASC" : "DESC"
    },
    onCompleted: data => {
      const resultPDF = data?.downloadPdfOrder?.exportedFileBase64;
      if (resultPDF) {
        const linkSource = `data:application/pdf;base64,${resultPDF}`;
        const downloadLink = document.createElement("a");
        const fileName = data?.downloadPdfOrder?.fileName;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      }
    }
  });

  const [
    callAddNewOrderLine,
    { loading: loadingAddNewItem }
  ] = useChangeOrderAddNewOrderLineMutation({
    onError: error => {
      setOrderProcessStatus(OrderProcessStatus.failed);

      if (error.message === "Network request failed") {
        setOrderProcessError("400");
      } else {
        setOrderProcessError(error.message);
      }
    },
    onCompleted: async data => {
      if (data?.changeOrderAddNewOrderLine?.success) {
        const params: Record<string, string> = {};

        // Submit CashSale
        if (isCashSaleOrder && isEditableCashSale) {
          const orderId = dataChangeOrder?.changeOrder?.orderId;
          const cashSaleStatus = await handleSubmitCashSaleUpdate(orderId, {
            forceUpdate: true
          });
          params.cashSaleStatus = cashSaleStatus;
        }

        navigate(buildUrl(previewOrderPath(id), params));

        if (data?.changeOrderAddNewOrderLine?.iPlanMessages?.length > 0) {
          const iplanErrList = data?.changeOrderAddNewOrderLine?.iPlanMessages?.map(
            item => `${item.firstCode}${item.secondCode} - ${item.message}`
          );

          notify({
            status: "error",
            sourceSystem: "IPLAN",
            apiMessage: iplanErrList.join("\n")
          });
        }
        if (
          data?.changeOrderAddNewOrderLine?.iplanConfirmFailedErrors.length > 0
        ) {
          notify({
            title: "Something Went Wrong",
            status: "error",

            apiMessage: data?.changeOrderAddNewOrderLine?.iplanConfirmFailedErrors
              ?.map(item => `Error :  ${item.field}\n ${item.message}`)
              .join("<br>"),
            autohide: null
          });
        }
      } else {
        setOrderProcessStatus(OrderProcessStatus.inconclusive);

        if (
          data?.changeOrderAddNewOrderLine?.sapOrderMessages?.length > 0 ||
          data?.changeOrderAddNewOrderLine?.sapItemMessages?.length > 0
        ) {
          const sapErrorOrders =
            data?.changeOrderAddNewOrderLine?.sapOrderMessages?.map(
              ({ errorCode, errorMessage }) => `${errorCode} - ${errorMessage}`
            ) || [];

          const sapErrorItems =
            data?.changeOrderAddNewOrderLine?.sapItemMessages?.map(
              ({ itemNo, errorMessage, errorCode }) => ({
                itemNo,
                itemCode: `${errorCode || ""}`,
                itemStatus: errorMessage
              })
            ) || [];

          setDialogError(true);
          setErrorSource("SAP");
          setErrorOrders(sapErrorOrders);
          setErrorItems(sapErrorItems);
        } else if (
          data?.changeOrderAddNewOrderLine?.isRedirectPreview &&
          data?.changeOrderAddNewOrderLine?.iPlanMessages?.length > 0
        ) {
          navigate(previewOrderPath(id));
          const iplanErrorItems = data?.changeOrderAddNewOrderLine?.iPlanMessages?.map(
            item => ({
              itemNo: item.itemNo,
              itemCode: `${item.firstCode}${item.secondCode}`,
              itemStatus: item.message
            })
          );
          notify({
            status: "error",
            title: "Something went wrong",
            text: (
              <>
                <Box>
                  <b>Error IPLAN</b>
                </Box>
                {iplanErrorItems.map(item => (
                  <Box key={item.itemNo}>{item.itemStatus}</Box>
                ))}
              </>
            )
          });
        } else if (
          data?.changeOrderAddNewOrderLine?.iPlanMessages?.length > 0
        ) {
          const iplanErrorItems = data?.changeOrderAddNewOrderLine?.iPlanMessages?.map(
            item => ({
              itemNo: item.itemNo,
              itemCode: `${item.firstCode}${item.secondCode}`,
              itemStatus: item.message
            })
          );

          setDialogError(true);
          setErrorSource("IPLAN");
          setErrorItems(iplanErrorItems);
        } else {
          setOrderProcessStatus(OrderProcessStatus.failed);
          let sapOrderErrors = "";
          // eslint-disable-next-line chai-friendly/no-unused-expressions
          data?.changeOrderAddNewOrderLine?.errors?.length &&
            data?.changeOrderAddNewOrderLine?.errors?.forEach(({ message }) => {
              sapOrderErrors += `${message} \n`;
            });

          notify({
            status: "error",
            apiMessage: sapOrderErrors
          });
        }
      }
    }
  });

  const [
    onConfirmReverOnderLine,
    { loading: loadingUndoDeleteItem }
  ] = useUndoOrderLinesMutation({
    onCompleted(data) {
      if (data?.undoOrderLines?.success) {
        refetchChangeOrderData().then(() => {
          handleCloseConfirm();
        });
      } else {
        if (data?.undoOrderLines?.iPlanMessages?.length) {
          const errorMessages = data?.undoOrderLines?.iPlanMessages.map(
            item => `${item.firstCode}${item.secondCode} - ${item.message}`
          );

          notify({
            status: "error",
            sourceSystem: "IPLAN",
            apiMessage: errorMessages.join("\n")
          });
        } else {
          const sapErrorOrders = data?.undoOrderLines?.sapOrderMessages?.map(
            ({ errorCode, errorMessage }) =>
              `${errorCode || ""} - ${errorMessage}`
          );
          const sapErrorItems = data?.undoOrderLines?.sapItemMessages?.map(
            ({ itemNo, errorMessage, errorCode }) =>
              `${itemNo || ""} ${errorCode || ""} - ${errorMessage}`
          );
          showErrorNotification(sapErrorOrders, sapErrorItems);
        }
        handleCloseConfirm();
      }
    }
  });

  const [
    callSubmitOrder,
    { loading: loadingSubmitOrder }
  ] = useChangeOrderUpdateMutation({
    onError: error => {
      if (error?.message?.includes("Read timed out")) {
        setOrderProcessStatus(OrderProcessStatus.timeOut);
        return;
      }
      setOrderProcessStatus(OrderProcessStatus.failed);

      if (error.message === "Network request failed") {
        setOrderProcessError("400");
      } else {
        setOrderProcessError(error.message);
      }
    },
    onCompleted: async data => {
      if (data?.changeOrderUpdate?.success) {
        const params: Record<string, string> = {};
        params.rootPage = "changeOrder";

        // Submit CashSale
        if (isCashSaleOrder && isEditableCashSale) {
          const { isEdited } = findChangeOrderCashSaleEditedField(
            cashSaleFormProps.formik
          );
          const hasPriceAffectingChanges = checkHasPriceAffectingChanges(
            listLineOrder,
            listLineOrderInitial
          );
          if (isEdited || hasPriceAffectingChanges) {
            const orderId = dataChangeOrder?.changeOrder?.orderId;
            const cashSaleStatus = await handleSubmitCashSaleUpdate(orderId, {
              forceUpdate: hasPriceAffectingChanges
            });
            params.cashSaleStatus = cashSaleStatus;
          }
        }

        if (data?.changeOrderUpdate?.sapWarningMessages?.length > 0) {
          notify({
            title: "Warning",
            status: "warning",
            apiMessage: data?.changeOrderUpdate?.sapWarningMessages
              ?.map(item => `${item.order} - ${item.message}`)
              .join("\n"),
            autohide: null
          });
        }

        const urlId = data?.changeOrderUpdate?.order?.id || id;
        navigate(buildUrl(previewOrderPath(urlId), params));

        if (data?.changeOrderUpdate?.iPlanMessages?.length > 0) {
          const iplanErrList = data?.changeOrderUpdate?.iPlanMessages?.map(
            item => `${item.firstCode}${item.secondCode} - ${item.message}`
          );

          notify({
            status: "error",
            sourceSystem: "IPLAN",
            apiMessage: iplanErrList.join("\n")
          });
        }

        if (data?.changeOrderUpdate?.iplanConfirmFailedErrors?.length > 0) {
          notify({
            title: "Something Went Wrong",
            status: "error",

            apiMessage: data?.changeOrderUpdate?.iplanConfirmFailedErrors
              ?.map(item => `Error :  ${item.field}\n ${item.message}`)
              .join("<br>"),
            autohide: null
          });
        }
      } else {
        setOrderProcessStatus(OrderProcessStatus.inconclusive);
        if (
          data?.changeOrderUpdate?.sapOrderMessages?.length > 0 ||
          data?.changeOrderUpdate?.sapItemMessages?.length > 0
        ) {
          const sapErrorOrders = data?.changeOrderUpdate?.sapOrderMessages?.map(
            ({ errorCode, errorMessage }) =>
              `${errorCode || ""} - ${errorMessage}`
          );

          const sapErrorItems = data?.changeOrderUpdate?.sapItemMessages?.map(
            ({ itemNo, errorMessage, errorCode }) => ({
              itemNo,
              itemCode: `${errorCode || ""}`,
              itemStatus: errorMessage
            })
          );

          setDialogError(true);
          setErrorSource("SAP");
          setErrorOrders(sapErrorOrders);
          setErrorItems(sapErrorItems);
        } else if (data?.changeOrderUpdate?.iPlanMessages?.length > 0) {
          const iplanErrorItems = data?.changeOrderUpdate?.iPlanMessages?.map(
            item => ({
              itemNo: item.itemNo,
              itemCode: `${item.firstCode}${item.secondCode}`,
              itemStatus: item.message
            })
          );

          setDialogError(true);
          setErrorSource("IPLAN");
          setErrorItems(iplanErrorItems);
        } else {
          setOrderProcessStatus(OrderProcessStatus.failed);
          let sapOrderErrors = "";
          // eslint-disable-next-line chai-friendly/no-unused-expressions
          data?.changeOrderUpdate?.errors?.length &&
            data?.changeOrderUpdate?.errors?.forEach(({ message }) => {
              sapOrderErrors += `${message} \n`;
            });

          notify({
            status: "error",
            apiMessage: sapOrderErrors
          });
        }
      }
    }
  });

  const [submitCashSaleUpdate] = useSubmitCashSaleUpdateMutation();

  const handleSubmitCashSaleUpdate = async (
    orderId: string,
    options?: { forceUpdate: boolean }
  ) => {
    const formikCashSale = cashSaleFormProps?.formik;
    const payload = prepareCashSalePayload(orderId, formikCashSale, {
      forceUpdate: !!options?.forceUpdate
    });
    const { data } = await submitCashSaleUpdate(payload);
    return data?.submitCashSaleUpdate?.cashSaleStatus;
  };

  const getConditionPriceUnitByItemNo = (
    _itemNo: string,
    weightPerUnit: number
  ) => {
    const _conditionPriceUnitByItemNo = dataChangeOrder?.changeOrder?.orderCondition?.find(
      item => item?.itemNo === _itemNo && item?.conditionType === CONDITION_TYPE
    );
    return Number(_conditionPriceUnitByItemNo?.conditionRate) * weightPerUnit;
  };

  const mapReasonRejectToStatus = reason => {
    if (reason === "93") {
      return StatusCancel.CANCEL;
    }
    return "";
  };

  const mapRequestDateChangeReason = requestDateChangeReason => {
    if (requestDateChangeReason.includes("C3")) {
      return ReasonForChangeRequestDateEnum.C3;
    } else if (requestDateChangeReason.includes("C4")) {
      return ReasonForChangeRequestDateEnum.C4;
    } else {
      return requestDateChangeReason;
    }
  };

  useEffect(() => {
    if (dataChangeOrder || cancelEditCall) {
      const calculator = {};
      const orderLines = dataChangeOrder?.changeOrder?.orderItems || [];
      orderLines.forEach(line => {
        const key = `${line.contractProductId}`;
        const weightPerUnitBySaleFactor = Number(line.saleQtyFactor) / 1000;
        if (calculator[key]) {
          if (isProductCateg1) {
            calculator[key] =
              calculator[key] +
              weightPerUnitBySaleFactor * Number(line.itemQty);
          } else {
            calculator[key] = calculator[key] + Number(line.itemQty);
          }
        } else {
          if (isProductCateg1) {
            calculator[key] =
              weightPerUnitBySaleFactor * Number(line.itemQty) +
              line.remainWeight;
          } else {
            calculator[key] = Number(line.itemQty) + line.remainWeight;
          }
        }
      });

      let listLine: any[] =
        orderLines.map(item => {
          const weightPerUnitBySaleFactor = Number(item.saleQtyFactor) / 1000;
          return {
            ...item,
            orderNo: dataChangeOrder?.changeOrder?.soNo,
            status: dataChangeOrder?.changeOrder?.status,
            rootUnit: getConditionPriceUnitByItemNo(
              item.itemNo,
              weightPerUnitBySaleFactor
            ),
            weightUnit: item.weightDisplay,
            weightBase: weightPerUnitBySaleFactor,
            remainWeight: calculator[`${item.contractProductId}`] || 0,
            productInformation: item.product_Information,
            pricePerUnit: item.netPrice,
            originQuantity: item.itemQty,
            isEditRequestDate: false,
            initRequestDate: item.requestedDate,
            saleQtyFactor: item.saleQtyFactor,
            quantity: item.itemQty,
            errorQuantity: false,
            errorDateMessage: "",
            statusCancel: item.reasonReject
              ? mapReasonRejectToStatus(item.reasonReject)
              : "",
            requestDate: item.requestedDate
              ? moment(item.requestedDate, "DD/MM/YYYY").format("YYYY-MM-DD")
              : "",
            deliveryTolUnlimited:
              item.deliveryTolUnlimited === DeliveryUnlimited.X,
            requestDateChangeReason: item.requestDateChangeReason
              ? mapRequestDateChangeReason(item.requestDateChangeReason)
              : "",
            writable: true
          };
        }) || [];

      setItemNoLatest(Number(dataChangeOrder?.changeOrder?.itemNoLatest));

      /* const lineIncludeSplit = [];
      listLine.forEach(item => {
        // if (item.iplan) {
        //   item.iplan = {};
        //   item.iplan.iplantConfirmQuantity = reCalculateAssignQuantity(item);
        // }
        lineIncludeSplit.push(item);
        if (item.splitItems.length) {
          item.hasSplit = true;
          item.originQuantity = item.itemQty;
          const listSplit = item.splitItems.map(split => ({
            ...split,
            originId: item.itemNo, // item.id
            isSplit: true,
            rootUnit: item.weightUnit,
            weightUnit: item.weightUnit,
            weight: calculateNewTotalWeightCommon(
              item?.quantity,
              Number(item?.weight),
              item?.weightUnit,
              item?.weightUnit
            ),
            weightPerUnit: item.weightPerUnit
          }));
          lineIncludeSplit.push(...listSplit);
        }
      }); */
      checkContractExpiredCompleteInvalid();
      if (listLineOrderNotCallAtpCTP.length > 0) {
        listLine = listLine.map(item => {
          listLineOrderNotCallAtpCTP.forEach(element => {
            if (item.itemNo === element.itemNo) {
              item = element;
            }
          });
          return item;
        });

        setListLineOrderNotCallAtpCTP([]);
        setIsOpenProcessingAtpCtp(false);
      }
      setListLineOrderInitial(listLine);
      setListLineOrder(listLine);
    }
  }, [dataChangeOrder?.changeOrder, cancelEditCall]);

  const loadingAll =
    loadingChangeOrder ||
    loadingDuplicate ||
    loadingDownloadPdf ||
    loadingSubmitOrder ||
    loadingCancelDeleteItem ||
    loadingUndoDeleteItem ||
    loadingAddNewItem ||
    loadingGetCashSaleStatus;

  const {
    currentData,
    next,
    prev,
    toFirst,
    toLast,
    disableNext,
    disablePrev
  } = usePaginationLocal(listLineOrder, settings.rowNumber);

  const setViewEditMode = (mode: ViewEditMode) => {
    dispatchAppState({
      type: "setViewEditMode",
      payload: {
        viewEditMode: mode
      }
    });
  };

  const toggleCreditBlock = () => {
    setOpenCreditBlock(prev => !prev);
  };

  const toggleCustomerBlock = () => {
    setOpenCustomerBlock(prev => !prev);
  };

  const { refetch: callCreditLimit } = useGetCreditLimitQuery({
    variables: {
      input: {
        contractNo: dataChangeOrder?.changeOrder?.contractNo,
        salesOrgCode: dataChangeOrder?.changeOrder?.salesOrg,
        soldToCode
      }
    },
    skip: true
  });

  const { refetch: callCustomerBlock } = useGetCustomerBlockQuery({
    skip: true
  });

  const handleCallCreditLimit = (callback: () => void) => {
    callCreditLimit({
      input: {
        contractNo: dataChangeOrder?.changeOrder?.contractNo,
        salesOrgCode: dataChangeOrder?.changeOrder?.salesOrg,
        soldToCode
      }
    }).then(({ data }) => {
      if (data?.getCreditLimit?.creditBlockStatus) {
        toggleCreditBlock();
        return;
      }
      callback();
    });
  };

  const handleCustomerBlockAndCreditBlockCommon = (callback: () => void) => {
    if (!isStaff) {
      callCreditLimit().then(res => {
        if (res?.data?.getCreditLimit?.creditBlockStatus && !isStaff) {
          toggleCloseCreateOrderError();
          return;
        }
        callback();
      });
    } else {
      if (dataChangeOrder?.changeOrder?.orderPartners) {
        const { partnerNo } = dataChangeOrder.changeOrder.orderPartners.find(
          orderPartner => orderPartner.partnerRole === "AG"
        );
        callCustomerBlock({
          input: { soldToCode: partnerNo }
        }).then(({ data }) => {
          if (data?.getCustomerBlock?.customerBlock) {
            toggleCustomerBlock();
            return;
          }
          handleCallCreditLimit(callback);
        });
      }
    }
  };

  const handleChangeToEditMode = () => {
    setViewEditMode(ViewEditMode.EDIT);
    setCancelEditCall(false);
  };

  const handleChangeMode = mode => {
    if (mode === ViewEditMode.EDIT) {
      setModeCustomerBlock(ViewEditMode.EDIT);
      handleCustomerBlockAndCreditBlockCommon(handleChangeToEditMode);
    } else {
      setComponentKey(componentKey + 1);
      setCancelEditCall(true);
      setViewEditMode(mode);
    }
  };

  const handleConfirmCustomerBlock = () => {
    toggleCustomerBlock();
    const callback =
      modeCustomerBlock === ViewEditMode.EDIT
        ? handleChangeToEditMode
        : handleOpenDrawAddProduct;
    handleCallCreditLimit(callback);
  };

  useEffect(() => {
    if (params.editMode) {
      setViewEditMode(params.editMode);
    }
  }, []);

  const getTitle = () =>
    viewEditMode === ViewEditMode.VIEW
      ? intl.formatMessage({ defaultMessage: "Order Details" })
      : viewEditMode === ViewEditMode.ADD
      ? intl.formatMessage({ defaultMessage: "Add new items" })
      : intl.formatMessage({ defaultMessage: "Edit Order" });

  const handleBack = () => {
    setDataModalConfirm({
      content: intl.formatMessage({
        defaultMessage:
          "กรุณากด “ยืนยัน” เพื่อยกเลิกการแก้ไขคำสั่งซื้อ หรือกด “กลับไป” เพื่อปิดหน้าต่างนี้"
      }),
      title: intl.formatMessage({ defaultMessage: "ยกเลิกการแก้ไขคำสั่งซื้อ" }),
      type: TypeConfirm.CANCEL
    });
    handleOpenConfirm();
  };

  const handleOpenConfirm = () => {
    setOpenConfirmOrder(true);
  };

  const handleCloseConfirm = () => {
    setDataModalConfirm({
      content: undefined,
      title: undefined,
      type: undefined,
      lineId: undefined,
      okText: undefined,
      cancelText: undefined
    });
    setOpenConfirmOrder(false);

    if (
      dataModalConfirm.type === TypeConfirm.SUBMIT &&
      shouldShowCashSaleWarningBeforeSave()
    ) {
      changeToCashSaleTab();
    }
  };

  const changeToCashSaleTab = () => {
    cashSaleFormProps.preventCashAmountAutoFillOnNextMount();
    setActiveTab(ChangeOrderCSTab.itemDetails);
    setActiveItemTab(ItemTab.tabD);
  };

  const mapRouteItem = item => {
    if (item.route) {
      const routeArr = item.route.split("-").map(text => text.trim());
      return routeArr.length ? routeArr[0] : item.routeId;
    } else {
      return item.routeId;
    }
  };

  const getInputParameter = item => {
    if (item === "Customer") {
      return InquiryMethodType.CUSTOMER;
    } else if (item === "Domestic") {
      return InquiryMethodType.DOMESTIC;
    }
    return InquiryMethodType.ASAP;
  };

  const formatLinesInputUpdate = () => {
    const listInputUpdate: ChangeOrderItemDetailsInput[] = [];

    listLineOrder
      .filter(item => !item.statusCancel)
      .forEach(item => {
        listInputUpdate.push({
          itemNo: item.itemNo,
          orderInformation: {
            deliveryTolerance: {
              under: Number(item.underDeliveryTol),
              over: Number(item.overDeliveryTol),
              unlimited: item.deliveryTolUnlimited
                ? DeliveryUnlimited.X
                : DeliveryUnlimited.Y
            },
            itemCategory: item.itemCategory,
            materialCode: item.material,
            plant: item.plant,
            poNo: item.poNumber,
            quantity: Number(item.itemQty),
            reasonForChangeRequestDate: item.requestDateChangeReason
              ? item.requestDateChangeReason
              : ReasonForChangeRequestDateEnum.X,
            requestDate: moment(item.requestDate).format("DD/MM/YYYY"),
            route: mapRouteItem(item),
            shippingPoint: item.shippingPoint,
            unit: item.salesUnit,
            weight: +item.weightPerUnit,
            weightUnit: item?.weightUnitTon
          },
          iplanDetails: {
            inputParameter: getInputParameter(item.inquiryMethod),
            consignmentLocation: item.consignmentLocation
              ? item.consignmentLocation
              : ""
          },
          additionalData: {
            shipToParty: item.shipTo.split(" - ")[0],
            internalCommentsToWarehouse: item.internalCommentsToWarehouse,
            externalCommentsToCustomer: item.externalCommentsToCustomer,
            shippingMark: item?.shippingMark
          },
          new: false
          // id: item.id,
          // itemNo: item.itemNo,
          // shipTo: item.shipTo,
          // productInformation: item.productInformation,
          // internalCommentsToLogistic: item.internalCommentsToLogistic,
          // internalCommentsToWarehouse: item.internalCommentsToWarehouse,
          // externalCommentsToCustomer: item.externalCommentsToCustomer,
          // requestDate: item.requestDate,
          // plant: item.plant,
          // quantity: Number(item.itemQty),
          // weightUnit: getWeightUnit(item),
          // // variantId: item.variant?.id,
          // itemCategory: item.itemCategory,
          // shippingPoint: item.shippingPoint,
          // route: item.route,
          // weight: Number(item.saleQtyFactor) / 1000,
          // requestDateChangeReason:
          //   /* item.requestDateChangeReason */ item.requestDateChangeReason, // TODO: req BE requestDateChangeReason
          // deliveryTolUnlimited: item.deliveryTolUnlimited || false,
          // overDeliveryTol: Number(item.overDeliveryTol),
          // underDeliveryTol: Number(item.underDeliveryTol),
          // poNo: item.poNo
        });
      });
    /* listLineOrder.forEach(item => {
      if (item.isSplit) {
        const originId = item.originId;
        const lineOrigin = listInputUpdate.find(line => line.id === originId);
        if (!lineOrigin.splitItems) {
          lineOrigin.splitItems = [];
        }
        lineOrigin.splitItems.push({
          id: item.id,
          quantity: item.quantity,
          requestDate: item.requestDate
            ? item.requestDate
            : lineOrigin.requestDate
        });
      }
    }); */
    return listInputUpdate;
  };

  const callSubmitOrderFunc = () => {
    setOrderProcessStatus(OrderProcessStatus.success);
    const poDate = dataModalConfirm?.dataHeader?.poDate || null;

    callSubmitOrder({
      variables: {
        soNo: id,
        input: {
          // status: ScgOrderStatus.CONFIRMED,
          header: {
            fixedData: {
              soNo: id,
              contractNo: dataChangeOrder?.changeOrder?.contractNo,
              poNo: dataChangeOrder?.changeOrder?.poNo,
              shipToCode: getShipToCode(),
              soldToCode,
              billToCode: getBillToCode()
            },
            partner: {
              shipTo: dataModalConfirm?.dataHeader?.shipTo.split(" - ")[0],
              billTo: dataModalConfirm?.dataHeader?.billTo.split(" - ")[0],
              poDate: poDate ? moment(poDate).format("DD/MM/YYYY") : poDate,
              customerGroup1: getId(
                dataCustomerGroup?.customerGroup1,
                dataModalConfirm?.dataHeader?.customerGroup1
              ),
              customerGroup2: getId(
                dataCustomerGroup?.customerGroup2,
                dataModalConfirm?.dataHeader?.customerGroup2
              ),
              customerGroup3: getId(
                dataCustomerGroup?.customerGroup3,
                dataModalConfirm?.dataHeader?.customerGroup3
              ),
              customerGroup4: getId(
                dataCustomerGroup?.customerGroup4,
                dataModalConfirm?.dataHeader?.customerGroup4
              ),
              incoterms1: getId(
                dataIncoterm?.incoterms1,
                dataModalConfirm?.dataHeader?.incoterm
              ),
              poNo: dataModalConfirm?.dataHeader?.poNo
            },
            additionalData: {
              internalCommentsToWarehouse:
                dataModalConfirm?.dataHeader?.internalCommentsToWarehouse,
              internalCommentsToLogistic:
                dataModalConfirm?.dataHeader?.internalCommentsToLogistic,
              externalCommentsToCustomer:
                dataModalConfirm?.dataHeader?.externalCommentsToCustomer,
              productionInformation:
                dataModalConfirm?.dataHeader?.productInformation
              // remark:
              // dataModalConfirm?.dataHeader?.remark
            }
          },
          itemDetails: formatLinesInputUpdate()
          // orderInformation: {
          //   poNumber: dataModalConfirm?.dataHeader?.poNo,
          //   billTo: dataModalConfirm?.dataHeader?.billTo,
          //   shipTo: dataModalConfirm?.dataHeader?.shipTo,
          //   customerGroup1Id: dataModalConfirm?.dataHeader?.customerGroup1,
          //   customerGroup2Id: dataModalConfirm?.dataHeader?.customerGroup2,
          //   customerGroup3Id: dataModalConfirm?.dataHeader?.customerGroup3,
          //   customerGroup4Id: dataModalConfirm?.dataHeader?.customerGroup4,
          //   poDate,
          //   productInformation:
          //     dataModalConfirm?.dataHeader?.productInformation,
          //   internalCommentsToLogistic:
          //     dataModalConfirm?.dataHeader?.internalCommentsToLogistic,
          //   internalCommentsToWarehouse:
          //     dataModalConfirm?.dataHeader?.internalCommentsToWarehouse,
          //   externalCommentsToCustomer:
          //     dataModalConfirm?.dataHeader?.externalCommentsToCustomer,
          //   requestDate: moment(
          //     dataChangeOrder?.changeOrder?.requestDate,
          //     "DD/MM/YYYY"
          //   ).format("YYYY-MM-DD"),
          //   deliveryBlock: dataModalConfirm?.dataHeader?.deliveryBlock,
          //   incotermsId: dataModalConfirm?.dataHeader?.incoterm,
          //   route: dataModalConfirm?.dataHeader?.route,
          //   shippingPoint: dataModalConfirm?.dataHeader?.shippingPoint
          // },
          // orderOrganizationData: {
          //   distributionChannelId:
          //     dataModalConfirm?.dataHeader?.distributionChannel,
          //   divisionId: dataModalConfirm?.dataHeader?.division,
          //   saleGroupId: dataModalConfirm?.dataHeader?.saleGroup,
          //   saleOfficeId: dataModalConfirm?.dataHeader?.saleOffice,
          //   saleOrganizationId: dataModalConfirm?.dataHeader?.saleOrganization
          // },
          // lines: formatLinesInputUpdate()
        }
      }
    });
  };

  const onTabClick = tab => {
    setActiveTab(tab);
  };

  useEffect(() => {
    if (dataChangeOrder) {
      setComponentKey(prev => prev + 1);
    }
  }, [dataChangeOrder]);

  const [countChange, setCountChange] = useState<number>(0);
  useEffect(() => {
    setCountChange(prev => prev + 1);
  }, [listLineOrder]);

  const getPriceData = () => {
    let totalPrice = 0;
    listLineOrder.forEach(line => {
      if (
        line.itemCategory === "ZTNN" ||
        line.itemCategory === "ZTN1" ||
        line.statusCancel === StatusCancel.CANCEL ||
        line.statusCancel === StatusCancel.DELETE
      ) {
        return;
      }
      if (line.quantity) {
        totalPrice += getTotalNetPriceByLine(line);
      }
    });
    const vat = totalPrice * TAX_PERCENT;
    const netPrice = totalPrice + vat;

    if (countChange <= 2) {
      return {
        itemCount:
          listLineOrder.filter(
            item => item.statusCancel !== StatusCancel.DELETE
          ).length || 0,
        orderAmtBeforeVat: Number(
          dataChangeOrder?.changeOrder?.orderAmtBeforeVat || 0
        ),
        orderAmtVat: Number(dataChangeOrder?.changeOrder?.orderAmtVat || 0),
        orderAmtAfterVat: Number(
          dataChangeOrder?.changeOrder?.orderAmtAfterVat || 0
        ),
        currency: dataChangeOrder?.changeOrder?.currency || ""
      };
    }

    return {
      itemCount:
        listLineOrder.filter(item => item.statusCancel !== StatusCancel.DELETE)
          .length || 0,
      orderAmtBeforeVat: totalPrice,
      orderAmtVat: vat,
      orderAmtAfterVat: netPrice,
      currency: dataChangeOrder?.changeOrder?.currency || ""
    };
  };

  const priceData = getPriceData();

  const cashSaleFormProps = useCashSaleForm({
    isEditable:
      [ViewEditMode.EDIT, ViewEditMode.ADD].includes(viewEditMode) &&
      isEditableCashSale,
    orderAmount: roundDecimal(priceData.orderAmtAfterVat, 2),
    arOutstandingResult,
    cashSaleData: dataChangeOrder?.changeOrder?.cashSale
  });

  const triggerApplyAll = () => {
    setApplyAllKey(prev => prev + 1);
  };

  const handleApplyAll = data => {
    const newList = [...listLineOrder];
    newList.forEach(item => {
      if (item.status !== "Disable") {
        item.billTo = data.billTo;
        item.externalCommentsToCustomer = data.externalCommentsToCustomer;
        item.internalCommentsToLogistic = data.internalCommentsToLogistic;
        item.internalCommentsToWarehouse = data.internalCommentsToWarehouse;
        item.productInformation = data.productInformation;
        item.requestDate = moment(
          dataChangeOrder?.changeOrder?.requestDate,
          "DD/MM/YYYY"
        ).format("YYYY-MM-DD");
        item.route = data.route;
        item.shipTo = data.shipTo;
        item.shippingPoint = data.shippingPoint;
      }
    });
    setListLineOrder(newList);
    setMode(ModeUpdate.ApplyAll);
    setSuccessfully(TypeOfApplyAll.Successfully);
    setApplyAllKey(0);
  };

  const handleCancelOrder = () => {
    setDataModalConfirmDelete({
      title: intl.formatMessage({ defaultMessage: "ยกเลิกคำสั่งซื้อ !" }),
      content: intl.formatMessage({
        defaultMessage:
          "กรุณากด “ยืนยัน” เพื่อยกเลิกคำสั่งซื้อนี้ หรือกด “กลับไป” เพื่อปิดหน้าต่างนี้"
      }),
      cancelText: intl.formatMessage({ defaultMessage: "กลับไป" }),
      okText: intl.formatMessage({ defaultMessage: "ยืนยัน" }),
      typeConfirm: typeConfirmDelete.cancelOrder
    });
    setOpenModalConfirmDelete(true);
  };

  const handleConfirmCancelOrder = () => {
    switch (dataModalConfirmDelete.typeConfirm) {
      case typeConfirmDelete.cancelOrder:
        cancelDeleteItem({
          variables: {
            soNo: dataChangeOrder?.changeOrder?.soNo,
            orderLines: listLineOrder.map(line => ({
              itemNo: line.itemNo,
              status: StatusCancel.CANCEL
            }))
          }
        }).then(({ data }) => {
          if (data?.cancelDeleteOrderLines?.status) {
            refetchChangeOrderData().then(() =>
              setViewEditMode(ViewEditMode.VIEW)
            );
            resetSelectItem();
          } else {
            const {
              sapOrderMessages,
              iPlanMessages,
              sapItemMessages
            } = data.cancelDeleteOrderLines;
            if (
              sapOrderMessages?.length ||
              iPlanMessages?.length ||
              sapItemMessages?.length
            ) {
              let messageError = "";
              let source = "";
              const sapError =
                sapItemMessages.length > 0
                  ? sapItemMessages
                  : sapOrderMessages || [];
              const iPlanError = iPlanMessages || [];
              if (sapError.length) {
                const sapErrorOrders = data?.cancelDeleteOrderLines?.sapOrderMessages?.map(
                  ({ errorCode, errorMessage }) =>
                    `${errorCode || ""} - ${errorMessage}`
                );

                const sapErrorItems = data?.cancelDeleteOrderLines?.sapItemMessages?.map(
                  ({ itemNo, errorMessage, errorCode }) =>
                    `${itemNo || ""} ${errorCode || ""} - ${errorMessage}`
                );
                showErrorNotification(sapErrorOrders, sapErrorItems);
              }
              if (iPlanError.length) {
                source = "iPlan";
                messageError = getIPlanMessages(iPlanError);
                notify({
                  status: "error",
                  title: "Something went wrong",
                  text: (
                    <>
                      {source && (
                        <Box>
                          <b>
                            Error
                            {`  ${source}`}
                          </b>
                        </Box>
                      )}
                      <Box>{messageError}</Box>
                    </>
                  )
                });
              }
            }
          }
        });
        break;
    }
    setOpenModalConfirmDelete(false);
  };

  const handleCancelItem = () => {
    setOpenModalConfirmCancel(true);
  };

  const confirmCancelItem = reason => {
    const selectedOrderLine = [];
    const newListLineOrder = listLineOrder.map(item => {
      if (listSelectItem.includes(item.itemNo)) {
        selectedOrderLine.push({
          itemNo: item.itemNo,
          status: reason
        });
        return {
          ...item,
          statusCancel: reason
        };
      }
      return item;
    });
    cancelDeleteItem({
      variables: {
        soNo: dataChangeOrder?.changeOrder?.soNo,
        orderLines: selectedOrderLine
      }
    }).then(({ data }) => {
      if (data?.cancelDeleteOrderLines?.status) {
        refetchChangeOrderData().then(() => {
          setOpenModalConfirmCancel(false);
        });
        resetSelectItem();
        setListLineOrder(newListLineOrder);
      } else {
        refetchChangeOrderData().then(() => {
          setOpenModalConfirmCancel(false);
        });
        resetSelectItem();
        setListLineOrder(
          newListLineOrder.map(item => {
            const listFailUpdate = [
              ...data.cancelDeleteOrderLines.iPlanMessages.map(
                line => line.itemNo
              ),
              ...data.cancelDeleteOrderLines.sapItemMessages.map(
                line => line.itemNo
              )
            ];
            return {
              ...item,
              statusCancel: listFailUpdate.includes(item.itemNo)
                ? ""
                : item.statusCancel
            };
          })
        );
        const {
          sapOrderMessages,
          iPlanMessages,
          sapItemMessages
        } = data.cancelDeleteOrderLines;
        if (
          sapOrderMessages?.length ||
          iPlanMessages?.length ||
          sapItemMessages?.length
        ) {
          let messageError = "";
          let source = "";
          const sapError =
            sapItemMessages.length > 0
              ? sapItemMessages
              : sapOrderMessages || [];
          const iPlanError = iPlanMessages || [];
          if (sapError.length) {
            const sapErrorOrders = data?.cancelDeleteOrderLines?.sapOrderMessages?.map(
              ({ errorCode, errorMessage }) =>
                `${errorCode || ""} - ${errorMessage}`
            );

            const sapErrorItems = data?.cancelDeleteOrderLines?.sapItemMessages?.map(
              ({ itemNo, errorMessage, errorCode }) =>
                `${itemNo || ""} ${errorCode || ""} - ${errorMessage}`
            );
            showErrorNotification(sapErrorOrders, sapErrorItems);
          }
          if (iPlanError.length) {
            source = "iPlan";
            messageError = getIPlanMessagesCancelItem(iPlanError);
            notify({
              status: "error",
              title: "Something went wrong",
              text: (
                <>
                  {source && (
                    <Box>
                      <b>
                        Error
                        {`  ${source}`}
                      </b>
                    </Box>
                  )}
                  <Box>{messageError}</Box>
                </>
              )
            });
          }
        }
      }
    });
  };

  const handleConfirmOrder = () => {
    if (dataModalConfirm.type === TypeConfirm.SUBMIT) {
      callSubmitOrderFunc();
      handleCloseConfirm();
    } else if (dataModalConfirm.type === TypeConfirm.CANCEL) {
      handleCloseConfirm();
      history.goBack();
    } else if (dataModalConfirm.type === TypeConfirm.REVERT) {
      onConfirmReverOnderLine({
        variables: {
          itemNo: dataModalConfirm?.item?.itemNo,
          soNo: dataModalConfirm?.item?.orderNo
        }
      });
    }
  };

  const handleRevertItem = (lineId, item?) => {
    setDataModalConfirm({
      type: TypeConfirm.REVERT,
      title: intl.formatMessage({ defaultMessage: "ดึง Order item นี้กลับ" }),
      content: intl.formatMessage({
        defaultMessage:
          "กรุณากด “ยืนยัน” เพื่อดำเนินการต่อ หรือกด “กลับไป” เพื่อปิดหน้าต่างนี้"
      }),
      cancelText: intl.formatMessage({ defaultMessage: "กลับไป" }),
      okText: intl.formatMessage({ defaultMessage: "ยืนยัน" }),
      lineId,
      item
    });
    setOpenConfirmOrder(true);
  };

  const handleCancelEdit = () => {
    setOpenCancelEdit(true);
  };

  const handleOpenATP = () => {
    const atpItem = listSelectItem.filter(
      item => !itemErrors?.includes(item) && !itemErrorsR5.includes(item)
    );

    const dataATP = atpItem?.map(item =>
      listLineOrder.find(line => line.itemNo === item)
    );

    setOpenDrawATP(true);
    setDataOpenATP(dataATP);
  };

  const [checkStatusAtpCtp] = useShowAtpCtpPopupLazyQuery({
    onCompleted(data) {
      if (data?.showAtpCtpPopup?.flag === "gidate") {
        setItemErrors(data.showAtpCtpPopup.itemErrors);
        setOpenGLDateErrorPopup(true);
      } else if (data?.showAtpCtpPopup?.flag === "status") {
        setItemErrors(data.showAtpCtpPopup.itemErrors);
        setOpenDialogAtpCtpError(true);
      } else {
        setItemErrors([]);
        handleOpenATP();
      }
    },
    fetchPolicy: "no-cache"
  });

  const handleClickAtpCtp = () => {
    const lineIds = [];
    const itemNoR5 = [];

    const data = listSelectItem.map(selectItem =>
      listLineOrder.find(item => item.itemNo === selectItem)
    );

    data.forEach(item => {
      if (item.flagR5) {
        itemNoR5.push(item.itemNo);
      } else {
        lineIds.push(item.id);
      }
    });

    if (itemNoR5.length) {
      setItemErrorsR5(itemNoR5);
      setOpenR5ErrorPopup(true);
    } else {
      checkStatusAtpCtp({
        variables: {
          lineIds
        }
      });
    }
  };

  const handleOpenDrawAddProduct = () => {
    setOpenDrawAddProduct(prev => !prev);
    getDataContract({
      variables: {
        id: dataChangeOrder?.changeOrder?.contractNo,
        soNo: dataChangeOrder?.changeOrder?.soNo
      }
    });
  };

  const handleAddItems = () => {
    if (
      dataCheckContractExpiredCompleteInvalid
        ?.checkContractExpiredCompleteInvalid?.isInvalid
    ) {
      setIsOpenInvalidOrderError(true);
      return;
    }
    setModeCustomerBlock(ViewEditMode.ADD);
    handleCustomerBlockAndCreditBlockCommon(handleOpenDrawAddProduct);
  };

  const handlePressSubmit = () => {
    setSubmitKey(prev => prev + 1);
  };

  const shouldShowCashSaleWarningBeforeSave = () =>
    isCashSaleOrder &&
    !cashSaleFormProps.formik?.values?.cashFlag &&
    !cashSaleFormProps.formik?.values?.balanceFlag;

  const handleSubmitOrder = async (dataHeader: ModalConfirm["dataHeader"]) => {
    setSubmitKey(0);

    let title = "บันทึกคำสั่งซื้อ";
    let content =
      "กรุณากด “ยืนยัน” เพื่อบันทึกคำสั่งซื้อ หรือกด “กลับไป” เพื่อปิดหน้าต่างนี้ี้";
    if (shouldShowCashSaleWarningBeforeSave()) {
      title = "คุณยังไม่ได้ระบุ “จำนวนเงินโอน” หรือ “เงินเหลือที่ต้องการใช้”";
      content =
        "คุณสามารถกด “ยืนยัน” เพื่อสร้างคำสั่งซื้อ หรือกด “กลับไป” เพื่อปิดหน้าต่างนี้";
    }
    setDataModalConfirm({
      type: TypeConfirm.SUBMIT,
      title: (
        <span className={classes.titleMain}>
          {intl.formatMessage({ defaultMessage: title })}
        </span>
      ),
      content: intl.formatMessage({ defaultMessage: content }),
      okText: intl.formatMessage({ defaultMessage: "ยืนยัน" }),
      cancelText: intl.formatMessage({ defaultMessage: "กลับไป" }),
      dataHeader
    });
    const newLine = listLineOrder.map(item => {
      // if (!(dataOrder?.contractOrder?.status === "Completed Delivery") && !item.hasSplit) {
      item.errorDate =
        !item.requestDate ||
        (item.isEditRequestDate &&
          moment(item.requestDate)
            .set("h", 1)
            .isBefore(moment().set("h", 0)));
      // }
      item.errorQuantity = item.errorQuantity
        ? item.errorQuantity
        : !item.itemQty;
      return item;
    });

    if (viewEditMode === ViewEditMode.ADD) {
      const isAddNewLineError = newLine.some(
        item => (item.errorDate || item.errorQuantity) && item.isNewAddItem
      );
      if (isAddNewLineError) {
        setListLineOrder(newLine);
        setActiveTab(ChangeOrderCSTab.itemDetails);
        setActiveItemTab(ItemTab.tabA);
        setOpenError(true);
        setSubmitKey(0);
        return;
      }

      const isValidCashSale = await validateAndRedirectCashSaleForm();
      if (!isValidCashSale) {
        return;
      }

      setOpenConfirmAddNewItem(true);
      return;
    }

    const isLineError = newLine.some(
      item => (item.isEditRequestDate && item.errorDate) || item.errorQuantity
    );
    if (isLineError) {
      setListLineOrder(newLine);
      setActiveTab(ChangeOrderCSTab.itemDetails);
      setActiveItemTab(ItemTab.tabA);
      setOpenError(true);
      setSubmitKey(0);
      return;
    }

    const isValidCashSale = await validateAndRedirectCashSaleForm();
    if (!isValidCashSale) {
      return;
    }

    setOpenConfirmOrder(true);
  };

  const validateAndRedirectCashSaleForm = async () => {
    if (isCashSaleOrder && isEditableCashSale) {
      const cashSaleErrors = await cashSaleFormProps.formik.validateForm();
      if (Object.keys(cashSaleErrors).length > 0) {
        changeToCashSaleTab();
        setOpenError(true);
        setSubmitKey(0);
        return false;
      }
    }
    return true;
  };

  const handleSort = field => {
    toFirst();
    const sortParam = getSortUrlVariables(field, params);
    const list = [...listLineOrder];
    switch (sortParam.sort) {
      case DomesticOrderSortField.item_no:
        if (sortParam.asc) {
          list.sort((itemA: any, itemB: any) => itemA.itemNo - itemB.itemNo);
          break;
        } else {
          list.sort((itemA: any, itemB: any) => itemB.itemNo - itemA.itemNo);
          break;
        }
      default:
        break;
    }
    setListLineOrder(list);
    navigate(
      changeOrderPathUrl(id, {
        ...params,
        ...getSortUrlVariables(field, params)
      }),
      { replace: true }
    );
  };

  const getShipToCode = () => {
    const shipTo = dataChangeOrder?.changeOrder?.orderPartners.find(
      item => item?.partnerRole === "WE" && item?.itemNo === "000000"
    );
    return shipTo.partnerNo;
  };

  const getShipToPartyName = () => {
    const _shipToPartyName = dataChangeOrder?.changeOrder?.orderPartners.find(
      item => item?.partnerRole === "WE" && item?.itemNo === "000000"
    );
    return `${_shipToPartyName?.partnerNo} - ${_shipToPartyName?.address[0]?.name}\n${_shipToPartyName?.address[0]?.street}, ${_shipToPartyName?.address[0]?.district}, ${_shipToPartyName?.address[0]?.city}`;
  };

  const getBillToCode = () => {
    const billTo = dataChangeOrder?.changeOrder?.orderPartners.find(
      item => item?.partnerRole === "RE"
    );
    return billTo.partnerNo;
  };

  const getBillToPartyName = () => {
    const _billToPartyName = dataChangeOrder?.changeOrder?.orderPartners.find(
      item => item?.partnerRole === "RE"
    );
    return `${_billToPartyName?.partnerNo} - ${_billToPartyName?.address[0]?.name}`;
  };

  const {
    isSelected: isSelectItem,
    listElements: listSelectItem,
    reset: resetSelectItem,
    toggle: toggleSelectItem,
    set: setSelectItem
  } = useBulkActions([]);

  const handleSplitData = originalId => {
    setListLineOrder(oldData => {
      const newData = [...oldData];
      const originalIndex = newData.findIndex(item => item.id === originalId);
      const splitedItems = newData.filter(
        item => item.originalId === originalId
      );
      const arrItemNo = oldData.map(item => +item.itemNo);
      const maxItemNo = Math.max(...arrItemNo);

      const splitedItem = cloneDeep(newData[originalIndex]);
      splitedItem.itemNo = String(maxItemNo + 10);
      splitedItem.isSplit = true;
      splitedItem.itemQty = null;
      splitedItem.quantity = null;
      splitedItem.requestDate = null;
      splitedItem.id = null;
      splitedItem.originalId = originalId;
      delete splitedItem?.hasSplit;
      delete splitedItem?.contractProductId;
      newData[originalIndex].hasSplit = true;
      newData.splice(originalIndex + splitedItems.length + 1, 0, splitedItem);
      return newData;
    });
    setSplitLineId(originalId);
  };
  const handleAddMoreData = data => {
    const isHasSomeNewItem = listLineOrder.some(item => item.isNewAddItem);
    let max = isHasSomeNewItem
      ? Number(_maxBy(listLineOrder, "itemNo").itemNo)
      : itemNoLatest;
    const formattedData = data.map(value => {
      const itemNo = max + 10;
      max += 10;
      return {
        ...value,
        itemNo,
        orderNo: dataChangeOrder?.changeOrder?.soNo,
        material: value?.variant?.code,
        materialDesc: value?.variant?.descriptionEn,
        requestDateChangeReason: value?.requestDateChangeReason,
        itemQty: String(value?.quantity),
        isNewAddItem: true,
        saleQtyFactor: value.weight * 1000,
        pricePerUnit: value.price,
        contractProductId: value?.contractProduct?.id,
        weightBase: value.weight,
        remainWeight: value?.contractProduct?.remain,
        deliveryTolUnlimited: false,
        salesUnit: value?.unit,
        shippingMark: value?.shippingMark || ""
      };
    });
    const newListOrderLine = [...formattedData, ...listLineOrder];
    newListOrderLine.sort(
      (itemA: any, itemB: any) => itemB.itemNo - itemA.itemNo
    );
    setListLineOrder(newListOrderLine);
    navigate(
      changeOrderPathUrl(id, {
        ...params,
        sort: DomesticOrderSortField.item_no,
        asc: false
      }),
      { replace: true }
    );
    setViewEditMode(ViewEditMode.ADD);
  };

  const handleDeleteSplitData = (itemNo, originalId) => {
    setListLineOrder(oldData => {
      const newData = [...oldData];
      let hasSplit = false;
      const originalIndex = newData.findIndex(item => item.id === originalId);

      const lineSameOrigin = newData.filter(
        line => line.originalId === originalId && line.itemNo !== itemNo
      );

      let leftQuantity = 0;

      lineSameOrigin.forEach(line => {
        const lineQuantity = line.itemQty || "0";
        leftQuantity += parseInt(lineQuantity, 10);
      });

      const listLineOrderRemoved = newData.filter(
        item => String(item.itemNo) !== String(itemNo)
      );

      listLineOrderRemoved.forEach(item => {
        if (item.originalId === originalId) {
          hasSplit = true;
        }
      });

      listLineOrderRemoved.forEach(item => {
        if (item.isSplit) {
          if (
            Number(item.itemQty) >= item.assignQuantity ||
            leftQuantity >= item.assignQuantity
          ) {
            item.errorQuantity = true;
          } else {
            item.errorQuantity = false;
          }
        }
      });

      newData[originalIndex].hasSplit = hasSplit;
      newData[originalIndex].itemQty = String(
        newData[originalIndex].originQuantity - leftQuantity
      );
      if (!listLineOrderRemoved.filter(item => item.isSplit).length) {
        setSplitLineId("");
      }
      return listLineOrderRemoved;
    });
    setComponentKey(prev => prev + 1);
  };

  const handleClearSpliteData = () => {
    clearErrorOrders();
    setListLineOrder(oldData => {
      const newData = [...oldData];
      const listLineOrderRemoved = newData.filter(
        item => Boolean(item.isSplit) !== true
      );

      if (!listLineOrderRemoved.filter(item => item.isSplit).length) {
        setSplitLineId("");
      }
      return listLineOrderRemoved;
    });
  };

  const isProductCateg1 = listLineOrder.some(item =>
    PROD_CATEG_1(item?.materialGroup1)
  );

  const renderHeaderTab = (
    <div
      data-testid="header-tab-container"
      className={cls({
        [classes.displayNone]:
          activeTab !== ChangeOrderCSTab.header ||
          viewEditMode === ViewEditMode.ADD
      })}
    >
      <HeaderTabView
        orderId={id}
        key={`header_${componentKey}`}
        dataOrder={dataChangeOrder?.changeOrder}
        applyAllKey={applyAllKey}
        onApplyAll={handleApplyAll}
        setBillToInsteaded={setBillToInsteaded}
        setShipToInsteaded={setShipToInsteaded}
        submitKey={submitKey}
        onSubmitForm={handleSubmitOrder}
        setActiveTabTotal={setActiveTab}
        setOpenError={setOpenError}
        setApplyKey={setApplyAllKey}
        setSubmitKey={setSubmitKey}
        activeTab={activeHeaderTab}
        setActiveTab={setActiveHeaderTab}
        cancelEditCall={cancelEditCall}
      />
    </div>
  );

  const renderItemDetailsTab =
    viewEditMode === ViewEditMode.VIEW ? (
      <ItemDetailsTab
        dataOrder={dataChangeOrder?.changeOrder}
        // shipToPartyName={getShipToPartyName()}
        key={`item_${componentKey}`}
        currentData={currentData()}
        listLineOrder={listLineOrder}
        setListLineOrder={setListLineOrder}
        loading={loadingAll}
        onUpdateListSettings={updateListSettings}
        settings={settings}
        hasNextPage={!disableNext()}
        hasPreviousPage={!disablePrev()}
        onNextPage={next}
        onPreviousPage={prev}
        onNextLastPage={toLast}
        onPreviousFirstPage={toFirst}
        sort={getSortParams(params)}
        onSort={handleSort}
        disabled={false}
        onRowClick={() => null}
        activeTab={activeItemTab}
        setActiveTab={setActiveItemTab}
        cashSaleFormProps={cashSaleFormProps}
      />
    ) : (
      <ItemDetailsTabEdit
        dataOrder={dataChangeOrder?.changeOrder}
        soldToCode={soldToCode}
        key={`itemedit_${componentKey}`}
        currentData={currentData()}
        listLineOrder={listLineOrder}
        setListLineOrder={setListLineOrder}
        loading={loadingAll}
        onUpdateListSettings={updateListSettings}
        settings={settings}
        hasNextPage={!disableNext()}
        hasPreviousPage={!disablePrev()}
        onNextPage={next}
        onPreviousPage={prev}
        onNextLastPage={toLast}
        onPreviousFirstPage={toFirst}
        isSelected={isSelectItem}
        listElements={listSelectItem}
        set={setSelectItem}
        reset={resetSelectItem}
        toggle={toggleSelectItem}
        handleRevertItem={handleRevertItem}
        sort={getSortParams(params)}
        disabled={false}
        onRowClick={() => null}
        onSort={handleSort}
        activeTab={activeItemTab}
        setActiveTab={setActiveItemTab}
        orderStatus={dataChangeOrder?.changeOrder?.status}
        handleSplitData={handleSplitData}
        handleDeleteSplitData={handleDeleteSplitData}
        splitLineId={splitLineId}
        setSplitLineId={setSplitLineId}
        refetchChangeOrder={refetchChangeOrderData}
        setViewEditMode={setViewEditMode}
        isOrderInvalid={
          dataCheckContractExpiredCompleteInvalid
            ?.checkContractExpiredCompleteInvalid?.isInvalid
        }
        disabledActionForCashSale={disabledActionForCashSale}
        cashSaleFormProps={cashSaleFormProps}
      />
    );

  const renderItemTabContainer = (
    <div
      data-testid="itemDetails-tab-container"
      className={cls({
        [classes.displayNone]:
          activeTab !== ChangeOrderCSTab.itemDetails ||
          viewEditMode === ViewEditMode.ADD
      })}
    >
      {renderItemDetailsTab}
    </div>
  );

  const renderAddNewItemContainer = (
    <div
      data-testid="addNewItem-tab-container"
      className={cls({
        [classes.displayNone]: viewEditMode !== ViewEditMode.ADD
      })}
    >
      <AddNewItem
        soNo={id}
        dataOrder={dataChangeOrder?.changeOrder}
        soldToCode={soldToCode}
        key={`AddNewItem_${componentKey}`}
        currentData={currentData()}
        listLineOrder={listLineOrder}
        setListLineOrder={setListLineOrder}
        loading={loadingAll}
        onUpdateListSettings={updateListSettings}
        settings={settings}
        hasNextPage={!disableNext()}
        hasPreviousPage={!disablePrev()}
        onNextPage={next}
        onPreviousPage={prev}
        onNextLastPage={toLast}
        onPreviousFirstPage={toFirst}
        isSelected={isSelectItem}
        listElements={listSelectItem}
        set={setSelectItem}
        reset={resetSelectItem}
        toggle={toggleSelectItem}
        handleRevertItem={handleRevertItem}
        sort={getSortParams(params)}
        disabled={false}
        onRowClick={() => null}
        onSort={handleSort}
        activeTab={activeItemTab}
        setActiveTab={setActiveItemTab}
        orderStatus={dataChangeOrder?.changeOrder?.status}
        handleSplitData={handleSplitData}
        handleDeleteSplitData={handleDeleteSplitData}
        onConfirmReloadPage={() => setOpenConfirmReload(true)}
        cashSaleFormProps={cashSaleFormProps}
      />
    </div>
  );

  const reloadPage = () => {
    refetchChangeOrderData();
  };

  const handleProcessCreateOrderFailed = () => {
    setOrderProcessStatus(OrderProcessStatus.inconclusive);
    if (orderProcessError === ErrorFields.CHECKOUT_OUTDATED_ERROR) {
      reloadPage();
    }
  };
  const onConfirmRefetchData = () => {
    setOpenConfirmReload(false);
    reloadPage();
  };

  const handleSortListProduct = createSortHandler(
    navigate,
    contractDetaiUrlParamTab(id),
    params
  );

  const handleCancelAddNewItem = () => {
    deleteAndSyncOrderLine({
      variables: {
        soNo: dataChangeOrder?.changeOrder?.soNo
      }
    });
    const newListOrderLine = [
      ...listLineOrder.filter(line => !line.isNewAddItem)
    ];
    newListOrderLine.sort(
      (itemA: any, itemB: any) => itemA.itemNo - itemB.itemNo
    );
    setListLineOrder(newListOrderLine);
    navigate(
      changeOrderPathUrl(id, {
        ...params,
        editMode: ViewEditMode.VIEW,
        sort: DomesticOrderSortField.item_no,
        asc: true
      }),
      { replace: true }
    );
    setOpenCancelAddNewItem(false);
    cashSaleFormProps.resetForm();
    setViewEditMode(ViewEditMode.VIEW);
  };

  const handleSubmitAddNewItem = () => {
    setOrderProcessStatus(OrderProcessStatus.success);
    setOpenConfirmAddNewItem(false);
    callAddNewOrderLine({
      variables: {
        input: {
          orderHeaders: {
            soNo: id,
            poNo: dataChangeOrder?.changeOrder?.poNo,
            contractNo: dataChangeOrder?.changeOrder?.contractNo,
            shipToCode: dataChangeOrder?.changeOrder?.orderPartners?.find(
              item => item?.partnerRole === "WE" && item?.itemNo === "000000"
            )?.partnerNo,
            soldToCode,
            billToCode: dataChangeOrder?.changeOrder?.orderPartners?.find(
              item => item?.partnerRole === "RE"
            )?.partnerNo
          },
          listNewItems: listLineOrder
            .filter(item => item.isNewAddItem)
            .map(line => ({
              refDocIt: line.refDocIt,
              itemNo: line.itemNo.toString(),
              additionalData: {
                shippingMark: line.shippingMark || "",
                externalCommentsToCustomer:
                  line.externalCommentsToCustomer || "",
                internalCommentsToWarehouse:
                  line.internalCommentsToWarehouse || "",
                shipToParty: line?.shipTo?.split("-")?.[0]?.trim() || ""
              },
              orderInformation: {
                materialCode: line.material,
                requestDate: moment(line.requestDate, "YYYY-MM-DD").format(
                  "DD/MM/YYYY"
                ),
                reasonForChangeRequestDate:
                  line.requestDateChangeReason ||
                  ReasonForChangeRequestDateEnum.X,
                quantity: Number(line.quantity),
                unit: line.salesUnit,
                weight: line.weightBase,
                weightUnit: line.weightUnit,
                plant: line.plant || "",
                itemCategory: line.itemCategory || "",
                shippingPoint: line.shippingPoint || "",
                route: mapRouteItem(line) || "",
                poNo: line.poNo || "",
                deliveryTolerance: {
                  over: Number(line.overDeliveryTol) || 0,
                  under: Number(line.underDeliveryTol) || 0,
                  unlimited: line.deliveryTolUnlimited
                    ? DeliveryUnlimited.X
                    : DeliveryUnlimited.Y
                }
              }
            }))
        }
      }
    });
  };

  // Modal Add Product
  const [getDataContract, { data: dataContract }] = useContractLazyQuery({
    fetchPolicy: "no-cache"
  });
  useEffect(() => {
    if (dataChangeOrder?.changeOrder?.contractNo && openDrawAddProduct) {
      getDataContract({
        variables: {
          id: dataChangeOrder?.changeOrder?.contractNo,
          soNo: dataChangeOrder?.changeOrder?.soNo
        }
      });
    }
  }, [dataChangeOrder?.changeOrder?.contractNo]);

  // const remainProductInOrderLinesCateg1 = useMemo(() => {
  //   const newList = [...formikItemTab.values.lines];
  //   const calculator = {};
  //   newList.forEach(line => {
  //     const total = calculator[line.contractProduct.id];
  //     if (total) {
  //       calculator[line.contractProduct.id] =
  //         total + Number(line.quantity || 0) * Number(line.variant.weight || 0);
  //     } else {
  //       calculator[line.contractProduct.id] =
  //         Number(line.quantity || 0) * Number(line.variant.weight || 0);
  //     }
  //   });
  //   return calculator;
  // }, [formikItemTab?.values?.lines]);

  const remainProductInOrderLinesCateg1 = useMemo(() => {
    const newList = [...listLineOrder];
    const calculator = {};
    newList.forEach(line => {
      const key = `${line.contractProductId}`;
      const total = calculator[key];
      if (total) {
        calculator[key] =
          total + Number(line.quantity || 0) * Number(line.weightBase || 0);
      } else {
        calculator[key] =
          Number(line.quantity || 0) * Number(line.weightBase || 0);
      }
    });
    return calculator;
  }, [listLineOrder]);

  const remainProductInOrderLines = useMemo(() => {
    const newList = [...listLineOrder];
    const calculator = {};
    newList.forEach(line => {
      const key = `${line.contractProductId}`;
      const total = calculator[key];
      if (total) {
        calculator[key] = total + Number(line.quantity || 0);
      } else {
        calculator[key] = Number(line.quantity || 0);
      }
    });
    return calculator;
  }, [listLineOrder]);

  const remainChangeOrder = useMemo(() => {
    const newList = [...listLineOrder];
    const calculator = {};
    newList.forEach(line => {
      const key = `${line.contractProductId}`;
      if (!calculator[key]) {
        calculator[key] = line.remainWeight;
      } else {
        calculator[key] = _max([calculator[key], line.remainWeight]);
      }
    });
    return calculator;
  }, [listLineOrder]);

  if (orderProcessStatus === OrderProcessStatus.timeOut) {
    return (
      <TimeOutPage
        timeOutText={
          <>
            <MyTypography variant={"body2"}>
              กรุณาตรวจสอบผลการแก้ไขคำสั่งซื้อที่เมนู Search Order/List of Sales
              Order
            </MyTypography>
          </>
        }
      />
    );
  }
  const isFlagR5 = !!listLineOrder.find(item => item.flagR5);

  return (
    <>
      {orderProcessStatus === OrderProcessStatus.inconclusive ? (
        <>
          <Container className={classes.boxContainer}>
            {!fullScreen ? (
              <>
                <MyTypography variant={"subtitle3"}>
                  {intl.formatMessage({
                    defaultMessage: "Change Order",
                    description: "subtitle"
                  })}
                </MyTypography>
                <PageHeader className={classes.pageHeader} title={getTitle()} />
                <AppHeader onBack={handleBack}>
                  <MyTypography variant="body3">
                    {intl.formatMessage({ defaultMessage: "กลับไป" })}
                  </MyTypography>
                </AppHeader>
                <TabContainer>
                  <div className={classes.tabBox}>
                    {viewEditMode === ViewEditMode.ADD ? (
                      <AddNewItemTab
                        testId="add-new-item-tab"
                        isActive
                        changeTab={onTabClick}
                      >
                        <MyTypography variant="h6" className={classes.tab}>
                          {intl.formatMessage({
                            defaultMessage: "Item Details",
                            description: "subtitle"
                          })}
                        </MyTypography>
                      </AddNewItemTab>
                    ) : (
                      <>
                        <HeaderTab
                          testId="header-tab"
                          isActive={activeTab === ChangeOrderCSTab.header}
                          changeTab={onTabClick}
                        >
                          <MyTypography variant="h6" className={classes.tab}>
                            {intl.formatMessage({
                              defaultMessage: "Header",
                              description: "subtitle"
                            })}
                          </MyTypography>
                        </HeaderTab>
                        <ItemDetailTab
                          testId="item-details-tab"
                          isActive={activeTab === ChangeOrderCSTab.itemDetails}
                          changeTab={onTabClick}
                        >
                          <MyTypography variant="h6" className={classes.tab}>
                            {intl.formatMessage({
                              defaultMessage: "Item Details",
                              description: "subtitle"
                            })}
                          </MyTypography>
                        </ItemDetailTab>
                      </>
                    )}
                  </div>
                </TabContainer>
                <Grid
                  container
                  spacing={2}
                  className={classes.boxInfo}
                  data-testid="order-info"
                >
                  <Grid item xs={12} md={5}>
                    <Grid container spacing={2} alignItems={"center"}>
                      <Grid item md={2}>
                        <MyTypography variant={"subtitle3"}>
                          S/O No.
                        </MyTypography>
                      </Grid>
                      <Grid item md={10}>
                        <MyTypography
                          variant={"subtitle1"}
                          className={classes.SoNo}
                          data-testid="soNo"
                        >
                          {dataChangeOrder?.changeOrder?.soNo}
                        </MyTypography>
                      </Grid>
                      <Grid item md={2}>
                        <MyTypography variant={"subtitle3"}>
                          Contract No.
                        </MyTypography>
                      </Grid>
                      <Grid item md={10}>
                        <MyTypography
                          variant={"body3"}
                          data-testid="contractNo"
                        >
                          {dataChangeOrder?.changeOrder?.contractNo}
                        </MyTypography>
                      </Grid>
                      <Grid item md={2}>
                        <MyTypography variant={"subtitle3"}>
                          Sold-to Party
                        </MyTypography>
                      </Grid>
                      <Grid item md={10}>
                        <MyTypography
                          variant={"body3"}
                          data-testid="soldToParty"
                        >
                          {getSoldToText()}
                        </MyTypography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={5}>
                    <Grid container spacing={2} alignItems={"center"}>
                      <Grid item md={3}>
                        <MyTypography variant={"subtitle3"}>
                          PO No.
                        </MyTypography>
                      </Grid>
                      <Grid item md={9}>
                        <MyTypography variant={"body3"} data-testid="poNo">
                          {dataChangeOrder?.changeOrder?.poNo}
                        </MyTypography>
                      </Grid>
                      <Grid item md={3}>
                        <MyTypography variant={"subtitle3"}>
                          Ship-to Party
                        </MyTypography>
                      </Grid>
                      <Grid item md={9}>
                        <MyTypography
                          variant={"body3"}
                          data-testid="shipToParty"
                        >
                          {shipToInsteaded.split("\n")[0] ||
                            getShipToPartyName()?.split("\n")[0]}
                        </MyTypography>
                      </Grid>
                      <Grid item md={3}>
                        <MyTypography variant={"subtitle3"}>
                          Bill-to Party
                        </MyTypography>
                      </Grid>
                      <Grid item md={9}>
                        <MyTypography
                          variant={"body3"}
                          data-testid="billToParty"
                        >
                          {billToInsteaded.split("\n")[0] ||
                            getBillToPartyName()}
                        </MyTypography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <Grid container spacing={1}>
                      <Grid item md={6}>
                        <MyTypography variant={"subtitle3"}>
                          eOrdering Status
                        </MyTypography>
                      </Grid>
                      <Grid item md={6}>
                        <MyTypography
                          variant={"body3"}
                          className={cls({
                            [classes.textRed]:
                              dataChangeOrder?.changeOrder?.status ===
                              "Cancelled"
                          })}
                          data-testid="status"
                        >
                          {dataChangeOrder?.changeOrder?.status}
                        </MyTypography>
                      </Grid>
                    </Grid>

                    {isCashSaleOrder && (
                      <Grid container spacing={1}>
                        <Grid item md={6}>
                          <MyTypography variant={"subtitle3"}>
                            Cash Sale Status
                          </MyTypography>
                        </Grid>
                        <Grid item md={6}>
                          <MyTypography
                            variant={"body3"}
                            className={cls({
                              [classes.textRed]:
                                (cashSaleStatusData?.getCashSaleStatus &&
                                  !cashSaleStatusData?.getCashSaleStatus
                                    ?.status) ||
                                !!cashSaleStatusError
                            })}
                            data-testid="cashSaleStatus"
                          >
                            {getCashSaleStatusText(
                              cashSaleStatusData?.getCashSaleStatus?.statusName,
                              !!cashSaleStatusError
                            ) || "-"}
                          </MyTypography>
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                </Grid>

                {isOpenProcessingAtpCtp ? (
                  <Box className={classes.warpModalProcessing}>
                    <ModalProcessing className={classes.modalProcessing} />
                  </Box>
                ) : null}
              </>
            ) : (
              ""
            )}
            {renderHeaderTab}
            {renderItemTabContainer}
            {renderAddNewItemContainer}
          </Container>
          {openDrawATP && (
            <AtpCtpDialog
              setIsOpenProcessingAtpCtp={setIsOpenProcessingAtpCtp}
              displayByOrderNo
              open={openDrawATP}
              loading={loadingAtpCtp}
              isDisapearItem={isDisapearItem}
              handleSubmit={acceptAtpItem}
              listAtpCtp={dataDrawATP}
              // orderId={id}
              onClose={() => {
                setOpenDrawATP(false);
              }}
              itemNoLatest={itemNoLatest}
            />
          )}
          {!fullScreen ? (
            <ChangeOrderFooter
              isProductCateg1={isProductCateg1}
              isFlagR5={isFlagR5}
              splitLineId={splitLineId}
              taxPercent={TAX_PERCENT}
              loading={loadingAll}
              onSubmit={handlePressSubmit}
              activeTab={activeTab}
              priceData={priceData}
              onApplyAll={triggerApplyAll}
              onCancelItem={handleCancelItem}
              onATP={handleClickAtpCtp}
              onChangeMode={handleChangeMode}
              onPopup={handleAddItems}
              onSendMail={() => setOpenSendMail(true)}
              onDownload={downloadPdfOrder}
              onDuplicate={duplicateOrder}
              onCancelOrder={handleCancelOrder}
              handleCancelEdit={handleCancelEdit}
              onCancelAddNewItem={() => setOpenCancelAddNewItem(true)}
              status={dataChangeOrder?.changeOrder?.status}
              listSelect={listSelectItem}
              disabledActionForCashSale={disabledActionForCashSale}
            />
          ) : (
            ""
          )}
          <DialogConfirmChangeOrder
            onClose={handleCloseConfirm}
            open={openConfirmOrder}
            onOk={handleConfirmOrder}
            title={dataModalConfirm.title}
            content={dataModalConfirm.content}
            okText={dataModalConfirm.okText}
            cancelText={dataModalConfirm.cancelText}
            loading={
              loadingUndoDeleteItem ||
              networkStatusChangeOrder === NetworkStatus.refetch
            }
          />
          <DialogConfirmWarning
            onCancel={() => setOpenModalConfirmDelete(false)}
            onConfirm={handleConfirmCancelOrder}
            open={openModalConfirmDelete}
            okText={dataModalConfirmDelete.okText}
            cancelText={dataModalConfirmDelete.cancelText}
            title={dataModalConfirmDelete.title}
            content={dataModalConfirmDelete.content}
          />
          <DialogConfirm
            buttonClass={"defaultB"}
            title={"ยกเลิกเพิ่มรายการสินค้า"}
            content={
              'ยืนยัน" เพื่อยกเลิกเพิ่มรายการสินค้าทั้งหมด หรือกด "กลับไป" เพื่อปิดหน้าต่างนี้'
            }
            onCancel={() => setOpenCancelAddNewItem(false)}
            onConfirm={handleCancelAddNewItem}
            open={openCancelAddNewItem}
          />
          <DialogConfirm
            buttonClass={"defaultB"}
            title="ยกเลิกแก้ไขคำสั่งซื้อ"
            content="กรุณากด “ยืนยัน” เพื่อดำเนินการต่อ หรือกด “กลับไป” เพื่อปิดหน้าต่างนี้"
            onCancel={() => setOpenCancelEdit(false)}
            onConfirm={() => {
              handleChangeMode(ViewEditMode.VIEW);
              handleClearSpliteData();
              cashSaleFormProps.resetForm();
              setOpenCancelEdit(false);
            }}
            open={openCancelEdit}
          />
          <DialogConfirm
            titleClass={classes.titleGradient}
            buttonClass={"gradient"}
            title={dataModalConfirm.title}
            content={dataModalConfirm.content}
            okText={dataModalConfirm.okText}
            cancelText={dataModalConfirm.cancelText}
            onCancel={() => setOpenConfirmAddNewItem(false)}
            onConfirm={handleSubmitAddNewItem}
            open={openConfirmAddNewItem}
          />
          <DialogConfirmCancelItem
            onCancel={() => setOpenModalConfirmCancel(false)}
            onConfirm={confirmCancelItem}
            open={openModalConfirmCancel}
            loading={
              loadingCancelDeleteItem ||
              networkStatusChangeOrder === NetworkStatus.refetch
            }
          />
          <DrawAddProductDomestic
            soNo={dataChangeOrder?.changeOrder?.soNo}
            remainProductInOrderLinesCateg1={remainProductInOrderLinesCateg1}
            remainProductInOrderLines={remainProductInOrderLines}
            remainChangeOrder={remainChangeOrder}
            contract={dataContract?.contract}
            open={openDrawAddProduct}
            onClose={() => setOpenDrawAddProduct(false)}
            contractId={dataContract?.contract?.id}
            orderId={id}
            refetchData={refetchChangeOrderData}
            staffUpdate={STAFF_UPDATE.ADD_ORDER_DOMESTIC}
            sort={getSortParams(params)}
            onSort={handleSortListProduct}
            handleAddMoreData={handleAddMoreData}
            setVisibleDialogError={setOpenError}
            setPopUpContent={setPopUpContent}
          />
          {isSuccessfully && (
            <SnackbarAlert
              severity={isSuccessfully}
              open={!!isSuccessfully}
              onClose={() => setSuccessfully(null)}
              verticalCenter={true}
              anchorOrigin={{ horizontal: "center", vertical: "top" }}
            >
              <div
                className={classes.snackHeadTitle}
                data-testid="snackHeadTitle"
              >
                {mode === ModeUpdate.ApplyAll && (
                  <>
                    <MyTypography
                      variant="subtitle2"
                      style={{ color: "#ffffff", marginRight: "2px" }}
                    >
                      {intl.formatMessage({
                        defaultMessage: "APPLY ALL",
                        description: "dialog header"
                      })}
                    </MyTypography>
                    <MyTypography variant="body3" style={{ color: "#ffffff" }}>
                      {isSuccessfully === "success"
                        ? "ใช้กับ Item Details สำเร็จ"
                        : ""}
                    </MyTypography>
                  </>
                )}
              </div>
            </SnackbarAlert>
          )}
          <Backdrop open={!!isSuccessfully} className={classes.backDrop} />
          <DialogError
            onClose={() => {
              setOpenError(false);
              setPopUpContent(null);
            }}
            open={openError}
            body={popUpContent}
          />
          <DialogCreateOrderError
            onConfirm={toggleCloseCreateOrderError}
            open={openCreateOrderError}
            okText="ปิดหน้าต่าง"
            title="ไม่สามารถดำเนินการต่อได้"
            content={
              <span>
                <MyTypography variant="body2" className={classes.inlineBlock}>
                  เนื่องจาก Customer Credit :
                </MyTypography>{" "}
                <MyTypography
                  variant="subtitle2"
                  className={classes.inlineBlock}
                >
                  Credit Blocked
                </MyTypography>
              </span>
            }
          />
          <DialogError
            title="ไม่สามารถดำเนินการได้"
            width={372}
            body={
              <>
                <MyTypography component={"span"} variant="body2">
                  ไอเทมรายการ
                </MyTypography>
                <MyTypography component={"span"} variant="body2">
                  {`\t ${itemErrors?.length &&
                    itemErrors
                      .sort((itemA, itemB) => Number(itemA) - Number(itemB))
                      .join(", ")} \t`}
                </MyTypography>
                <MyTypography component={"span"} variant="body2">
                  ไม่สามารถดำเนินการตรวจสอบ ATP/CTP ได้
                  เนื่องจากได้มีการส่งสินค้าแล้ว
                </MyTypography>
              </>
            }
            confirmText={"ปิดหน้าต่าง"}
            onClose={() => {
              setOpenGLDateErrorPopup(false);
            }}
            open={openGLDateErrorPopup}
          />
          <DialogError
            title="ไม่สามารถดำเนินการได้"
            width={372}
            body={
              <>
                <MyTypography component={"span"} variant="body2">
                  ไอเทม
                </MyTypography>
                <MyTypography component={"span"} variant="body2">
                  {`\t ${itemErrors?.length &&
                    itemErrors
                      .sort((itemA, itemB) => Number(itemA) - Number(itemB))
                      .join(", ")} \t`}
                </MyTypography>
                <MyTypography component={"span"} variant="body2">
                  ไม่สามารถดำเนินการตรวจสอบ ATP/CTP ได้
                  เนื่องจากอยู่ระหว่างการผลิต หรือ ผลิตเสร็จแล้ว
                </MyTypography>
              </>
            }
            confirmText={"ปิดหน้าต่าง"}
            onClose={() => {
              setOpenDialogAtpCtpError(false);
            }}
            open={openDialogAtpCtpError}
          />
          <DialogError
            title="ไม่สามารถดำเนินการได้"
            width={372}
            body={
              <>
                <MyTypography component={"span"} variant="body2">
                  ไอเทมรายการ
                </MyTypography>
                <MyTypography component={"span"} variant="body2">
                  {`\t ${itemErrorsR5?.length &&
                    itemErrorsR5
                      .sort((itemA, itemB) => Number(itemA) - Number(itemB))
                      .join(", ")} \t`}
                </MyTypography>
                <MyTypography component={"span"} variant="body2">
                  ไม่สามารถดำเนินการตรวจสอบ ATP/CTP ได้ เนื่องจากติด R5
                </MyTypography>
              </>
            }
            confirmText={"ปิดหน้าต่าง"}
            onClose={() => {
              setOpenR5ErrorPopup(false);
            }}
            open={openR5ErrorPopup}
          />
          <ModalSendMail
            dataChangeOrder={dataChangeOrder}
            listLineOrder={listLineOrder}
            contractNo={dataChangeOrder?.changeOrder?.contractNo}
            saleOrg={dataChangeOrder?.changeOrder?.salesOrg}
            soldToCode={[soldToCode]}
            soldToName={getSoldToName()}
            orderId={[id]}
            open={openSendMail}
            onClose={() => setOpenSendMail(false)}
          />
        </>
      ) : (
        <OrderProcessingView
          orderProcessStatus={orderProcessStatus}
          onFailed={handleProcessCreateOrderFailed}
          errorCode={orderProcessError}
        />
      )}
      <CustomerBlockDialog
        content="Customer รายนี้ถูก Block ท่านต้องการเพิ่มรายการสินค้าในคำสั่งซื้อนี้?"
        open={openCustomerBlock}
        onConfirm={handleConfirmCustomerBlock}
        isViewOrder
        onClose={toggleCustomerBlock}
      />
      <CreditBlockDialog
        content="ไม่สามารถทำรายการได้ เนื่องจากลูกค้าติด
        (ฺCredit Block) กรุณาติดต่อเจ้าหน้าที่สินเชื่อ"
        open={openCreditBlock}
        onClose={toggleCreditBlock}
      />
      <InvalidModal
        title="ไม่สามารถเพิ่มรายการสินค้าได้"
        content="เนื่องจาก Contract Invalid/Completed"
        buttonContent="ปิดหน้าต่าง"
        open={isOpenInvalidOrderError}
        onClose={() => {
          setIsOpenInvalidOrderError(false);
        }}
      />
      <DialogConfirmError
        open={dialogError}
        onConfirm={() => setDialogError(false)}
        onCancel={() => setDialogError(false)}
        errorSource={errorSource}
        errorOrders={errorOrders}
        errorItems={errorItems}
      />
      <OrderBeingProcessError
        open={!!beingProcessMsg}
        onClose={() => setBeingProcessMsg("")}
        errorMessage={beingProcessMsg}
      />
      <DialogProcessing
        open={
          loadingChangeOrder ||
          loadingCancelDeleteItem ||
          loadingUndoDeleteItem ||
          loadingAtpCtp ||
          loadingInCoTerm ||
          loadingGetCashSaleStatus
        }
        description={"ระบบกำลังประมวลผล กรุณารอสักครู่"}
      />
      <DialogConfirm
        titleClass={classes.titleGradient}
        buttonClass={"gradient"}
        title={"ข้อมูลคำสั่งซื้อมีการเปลี่ยนแปลง"}
        content={`กดปุ่ม "ยืนยัน" เพื่อแสดงข้อมูลปัจจุบัน`}
        onCancel={() => setOpenConfirmReload(false)}
        onConfirm={onConfirmRefetchData}
        open={openConfirmReload}
      />
    </>
  );
};

export default ViewEditOrdersView;
